export const termsConditions = [
  {
    title: '',
    ul: [
      {
        mark: '',
        content:
          'ক্লায়েন্ট (বাজি ধরার যন্ত্র) হলেন এমন একজন ব্যক্তি যিনি বাজি কোম্পানির সাথে বাজি ধরেন।',
      },
      {
        mark: '',
        content:
          'বাজি হল ক্লায়েন্ট এবং বাজি কোম্পানির মধ্যে একটি চুক্তি যেখানে হেরে যাওয়া ব্যক্তিকে বাজি কোম্পানির দ্বারা নির্ধারিত নিয়ম অনুসারে তার বাধ্যবাধকতা পূরণ করতে হবে। বাজি কোম্পানির লাইনে দেওয়া নিয়ম অনুসারে বাজি গ্রহণ করা হয়।',
      },
      {
        mark: '',
        content:
          'লাইন হল বাজির জন্য বেটিং কোম্পানি কর্তৃক প্রদত্ত অডসে ইভেন্ট এবং তাদের ফলাফলের তালিকা।',
      },
      {
        mark: '',
        content:
          'বাজি হলো আর্থিক আমানত যা বাজি কোম্পানির প্রতি বাজিকরের বাধ্যবাধকতা পূরণের নিশ্চয়তা দেয়। বাজিকর এটি বাজি কোম্পানির ক্যাশ ডেস্কে বাজি ধরার ক্ষেত্রে অংশগ্রহণের জন্য ফি হিসেবে জমা করে, যার মধ্যে ফলাফলের পূর্বাভাস দেওয়া অন্তর্ভুক্ত। এটি বাজিকর যে পরিমাণ বাজি ধরছে তা।',
      },
      {
        mark: '',
        content: 'ফলাফল হল সেই ইভেন্টের ফলাফল যার উপর বাজি ধরা হয়েছে।',
      },
      {
        mark: '',
        content:
          'বিভিন্ন ইভেন্টের ফলাফলের জন্য বেটিং কোম্পানির উদ্ধৃতি হল জেতার সম্ভাবনা।',
      },
      {
        mark: '',
        content:
          'নিম্নলিখিত ক্ষেত্রে ব্যতীত, দলগত প্রতিযোগিতায় "হোম" (আয়োজক দল) এবং "অতিথি দল) ধারণাগুলি ব্যবহার করা হয়:',
        cul: [
          'রাউন্ডগুলি একটি শহর বা দেশে অনুষ্ঠিত হয় (আন্তর্জাতিক প্রতিযোগিতায়);',
          'এই ইভেন্টটি যেকোনো কাপ প্রতিযোগিতার ফাইনাল এবং এতে একটি ম্যাচ থাকে।',
        ],
      },
    ],
    content:
      '"হোম" দলগুলি বাজি ধরার লাইনে প্রথম স্থানে ("১" চিহ্নিত), এবং "অ্যাওয়ে" দলগুলি দ্বিতীয় স্থানে ("২" চিহ্নিত)।\n অন্যান্য ক্ষেত্রে, লাইনে অংশগ্রহণকারীদের সংখ্যা শর্তসাপেক্ষ, এবং ইভেন্টের স্থান সম্পর্কে তথ্য কেবল তথ্যবহুল।',
  },
  {
    title: 'সাধারণ শর্তাবলী',
    list: [
      {
        mark: '',
        content:
          '১. শর্তাবলী (এরপরে "নিয়ম" হিসাবে উল্লেখ করা হয়েছে) পরিষেবার বিধান নিয়ন্ত্রণ করে, যার মধ্যে spinbaji.com ওয়েবসাইটে জুয়া পরিষেবা প্রদানের উপর জনসাধারণের আনুগত্য চুক্তির বিধান অন্তর্ভুক্ত রয়েছে, যা বেটিং কোম্পানির এক পক্ষ এবং ক্লায়েন্টের অন্য পক্ষের মধ্যে সম্পাদিত হয়। ক্লায়েন্ট যখন ওয়েবসাইটে অনলাইনে নিবন্ধন করে, তখনই চুক্তিটি সম্পন্ন হওয়ার মুহূর্ত হিসেবে বিবেচিত হবে।',
      },
      {
        mark: '',
        content:
          '২. বেটিং কোম্পানি ক্লায়েন্টদের খেলাধুলার বাজির তালিকায়, অন্যান্য ইভেন্টে (এখন থেকে ইভেন্ট হিসেবে উল্লেখ করা হয়েছে), ওয়েবসাইটে উপস্থাপিত অন্যান্য গেমগুলিতে অংশগ্রহণের পরিষেবা প্রদান করে, ক্লায়েন্টদের ইন্টারনেটে ওয়েবসাইটে বাজির সম্ভাবনা তৈরি করতে এবং গেমিং অ্যাকাউন্ট পরিচালনা করার সুযোগ প্রদান করে। সমস্ত বাজি বর্তমান নিয়ম অনুসারে গৃহীত হয় (বিভিন্ন খেলার নিয়মের বিশেষ বৈশিষ্ট্য সহ)। বাজির তালিকায় ক্লায়েন্টদের অংশগ্রহণের পরিষেবা এবং ওয়েবসাইটে অন্যান্য গেমগুলিতে অংশগ্রহণের পরিষেবার জন্য একই গেমিং অ্যাকাউন্ট ব্যবহার করা হয়।',
      },
      {
        mark: '',
        content:
          '৩. নিবন্ধনের পর, ক্লায়েন্ট নিয়মগুলি মেনে নিয়েছেন বলে ধরে নেওয়া হবে, নিয়মগুলির সাথে সম্পূর্ণ পরিচিত হয়েছেন এবং সেই অনুযায়ী খেলতে সম্মত হয়েছেন, এবং তহবিল স্থানান্তরের জন্য সমস্ত চার্জ এবং কমিশনের হারের সাথে ক্লায়েন্ট সম্মত হয়েছেন এবং নতুন পরিষেবা সম্পর্কে ই-মেইল এবং এসএমএস বিজ্ঞপ্তিগুলির সাথে সম্মত হয়েছেন। ক্লায়েন্টের নিবন্ধনের অর্থ হল বেটিং কোম্পানির ব্যবহৃত সুরক্ষা বৈশিষ্ট্যগুলির সাথে তার সম্পূর্ণ সন্তুষ্টি এবং ক্লায়েন্ট টেলিফোন লাইন, ইন্টারনেট এবং যোগাযোগের অন্যান্য মাধ্যমের ব্যবহারের সাথে সম্পর্কিত সমস্ত ঝুঁকি সম্পূর্ণরূপে গ্রহণ করে। যদি ক্লায়েন্ট নিয়মগুলির সাথে একমত না হন, তাহলে তাকে বেটিং কোম্পানির দ্বারা প্রদত্ত পরিষেবাগুলি ব্যবহার বন্ধ করতে হবে।',
      },
      {
        mark: '',
        content:
          '৪. বেটিং কোম্পানি পূর্বের ব্যক্তিগত নোটিশ ছাড়াই বর্তমান নিয়ম, বিধান এবং অর্থ প্রদানের পদ্ধতি সংশোধন এবং পরিপূরক করতে পারে। পূর্বে স্থাপন করা বাজির শর্তাবলী অপরিবর্তিত থাকবে এবং পরবর্তী সমস্ত বাজির পরিবর্তিত নিয়মের অধীন হবে।',
      },
      {
        mark: '',
        content:
          '৫. নিবন্ধন, আমানত অ্যাকাউন্ট খোলা এবং বাজি ধরা কেবলমাত্র ১৮ বছর বয়সী ব্যক্তিদের জন্যই অনুমোদিত। ক্লায়েন্টরা তাদের বসবাসের দেশগুলিতে অনলাইন বাজি ধরার অনুমতি আছে কিনা তা যাচাই করার জন্য দায়ী। ক্লায়েন্টরা প্রয়োজনে তাদের স্থানীয় কর্তৃপক্ষকে জয় এবং ক্ষতি সম্পর্কে তথ্য দেওয়ার জন্য দায়ী। ক্লায়েন্টের নিবন্ধনের অর্থ হল ক্লায়েন্ট গ্যারান্টি দেয় যে ক) তিনি ১৮ বছর বয়সে পৌঁছেছেন এবং পরিষেবা গ্রহণের সময় বসবাসের দেশের আইন বা ক্লায়েন্ট যেখানে অবস্থিত সেই দেশের আইন অনুসারে, ক্লায়েন্টের বেটিং কোম্পানি কর্তৃক প্রদত্ত পরিষেবা গ্রহণের অধিকার রয়েছে; খ) তিনি তার গেমিং অ্যাকাউন্টে জমা করা তহবিলের বৈধ মালিক।',
      },
      {
        mark: '',
        content:
          '৬. বেটিং কোম্পানি ধরে নেয় যে রেজিস্ট্রেশনের সময় ক্লায়েন্ট কর্তৃক প্রদত্ত তথ্য সম্পূর্ণ সঠিক। যদি ক্লায়েন্ট বেটিং কোম্পানিকে ভুল তথ্য প্রদান করে তবে বেটিং কোম্পানি কোন দায় স্বীকার করবে না। ক্লায়েন্ট নিশ্চিত করে যে বেটিং কোম্পানিকে তার দ্বারা প্রদত্ত সমস্ত তথ্য সত্য। প্রতারণা এবং অন্যান্য দ্বন্দ্ব প্রতিরোধ করার জন্য, বেটিং কোম্পানি ক্লায়েন্টদের কাছ থেকে বেটিং কোম্পানি কর্তৃক প্রয়োজনীয় এবং পর্যাপ্ত ব্যক্তিগত সনাক্তকরণ নথি সরবরাহ করার জন্য অনুরোধ করতে পারে, যাতে রেজিস্ট্রেশনের সময় ক্লায়েন্ট কর্তৃক প্রদত্ত তথ্য যাচাই করা যায়। বেটিং কোম্পানি অনুরোধ করলে, ক্লায়েন্ট রেজিস্ট্রেশনের সময় সমস্ত প্রয়োজনীয় নথি জমা দিতে সম্মত হয়।',
      },
      {
        mark: '',
        content:
          '৭. যেসব ক্ষেত্রে প্রতারণামূলক কার্যকলাপ সন্দেহজনক, বিশেষ করে আর্থিক লেনদেন এবং বাজির সাথে সম্পর্কিত, দোষী সাব্যস্ত ব্যক্তিদের জবাবদিহি করা হবে, যার মধ্যে ফৌজদারি মামলার মুখোমুখি হওয়ার সম্ভাবনাও অন্তর্ভুক্ত। যদি বেটিং কোম্পানি জানতে পারে যে ক্লায়েন্ট ১৮ বছর বয়সে পৌঁছায়নি, এবং ক্লায়েন্টের পক্ষ থেকে কোনও প্রতারণামূলক বা অন্যান্য অবৈধ কার্যকলাপ সনাক্ত করা হলে, বেটিং কোম্পানি ক্লায়েন্টের গেমিং অ্যাকাউন্ট ব্লক করতে পারে এবং নিয়ম অনুসারে ক্লায়েন্টের ক্রিয়াকলাপ তদন্ত করতে পারে।',
      },
      {
        mark: '',
        content:
          '৮. অ্যাকাউন্ট খোলা এবং আমানত অ্যাকাউন্টে জমা করা হবে যে নিয়মের অধীনে।',
      },
      {
        mark: '',
        content: '৯. যথাযথ নিয়ম অনুসারে অর্থ প্রদান করা হয়।',
      },
      {
        mark: '',
        content:
          '১০. ক্লায়েন্টরা তাদের পাসওয়ার্ড এবং অ্যাকাউন্টের তথ্যের গোপনীয়তা বজায় রাখার জন্য সম্পূর্ণরূপে দায়ী। বেটিং কোম্পানি নিশ্চিত করে যে ক্লায়েন্টের তথ্য গোপন থাকবে। তবে, তথ্যটি যদি তৃতীয় পক্ষের কাছে প্রকাশ করা হয় তবে বেটিং কোম্পানি কোনও দায়বদ্ধতা অস্বীকার করে। লগইন/গেমিং অ্যাকাউন্ট নম্বর এবং গেমিং অ্যাকাউন্টধারীর পাসওয়ার্ড ব্যবহার করে পরিচালিত কার্যক্রম বৈধ এবং আনুষ্ঠানিক বলে বিবেচিত হয়। একমাত্র সীমাবদ্ধতা হল গেমিং অ্যাকাউন্টে উপলব্ধ ব্যালেন্স। যদি ক্লায়েন্ট সন্দেহ করে যে তাদের তথ্যের সাথে আপোস করা হয়েছে, তাহলে তারা পাসওয়ার্ড পরিবর্তনের জন্য বেটিং কোম্পানির প্রশাসকের সাথে যোগাযোগ করতে পারেন।',
      },
      {
        mark: '',
        content:
          '১১. সাইট ব্যবহারের ফলে বা সাইটের বিষয়বস্তু দ্বারা সৃষ্ট ক্ষতি বা ক্ষতির জন্য বেটিং কোম্পানি কোনও দায়িত্ব গ্রহণ করবে না। একই কথা প্রযোজ্য যদি কোনও ব্যক্তির দ্বারা সাইটের বিষয়বস্তু ব্যবহার বা অপব্যবহার করা হয়, সাইটের সাথে সংযুক্ত হতে না পারা, সাইট ব্যবহারে অক্ষমতা, সাইটের কার্যকারিতা বা ডেটা প্রেরণে বিলম্ব, যোগাযোগ লাইনে ব্যর্থতা বা সাইটের বিষয়বস্তুতে কোনও ভুল, টাইপিং ত্রুটি বা বাদ পড়ে।',
      },
      {
        mark: '',
        content:
          '১২. প্রতিটি খেলার জন্য নির্দিষ্ট নিয়মগুলি সাধারণ নিয়মের চেয়ে অগ্রাধিকার পায়।',
      },
      {
        mark: '',
        content:
          '১৩. এই ওয়েবসাইটটি Castianes BV (রেজি. নম্বর ১৫৯৯৬৫) দ্বারা পরিচালিত এবং কুরাকাওতে Emancipatie Boulevard Dominico F.-এ নিবন্ধিত। “Don” Martina 31, Willemstad, Castianes BV CIL Curaçao Interactive Licensing NV দ্বারা প্রদত্ত একটি সাবলাইসেন্সের মাধ্যমে যথাযথভাবে লাইসেন্সপ্রাপ্ত, যা Curaçao-এর গভর্নর কর্তৃক জারি করা Master Gaming License #5536/JAZ অনুসারে।',
      },
      {
        mark: '',
        content:
          '১৪. সাইটের বিষয়বস্তু সঠিক কিনা তা নিশ্চিত করার জন্য আমরা সর্বাত্মক প্রচেষ্টা চালিয়ে যাচ্ছি, তবুও বর্তমান ইভেন্টের সমস্ত তথ্য কেবল তথ্যগত উদ্দেশ্যে। বর্তমান স্কোর বা ম্যাচের সময় কোনও ভুলের জন্য আমরা কোনও দায় স্বীকার করি না। আমরা আপনাকে সর্বদা বিকল্প তথ্যের উৎস ব্যবহার করার পরামর্শ দিচ্ছি।',
      },
      {
        mark: '',
        content:
          ' ১৫. বেটিং কোম্পানি আফগানিস্তান, আরুবা, অস্ট্রেলিয়া, অস্ট্রিয়া, বেলারুশ, বেলজিয়াম, বোনেয়ার, কুরাকাও, চেক প্রজাতন্ত্র, এস্তোনিয়া, ফ্রান্স, জার্মানি, হাঙ্গেরি, ইরান, ইরাক, আয়ারল্যান্ড, ইসরায়েল, ইতালি, কাহনাওয়াকে মোহাওক টেরিটরি (কানাডা), লাটভিয়া, উত্তর কোরিয়া, অন্টারিও (কানাডা), পাকিস্তান, রাশিয়া, সাবা, সার্বিয়া, সিঙ্গাপুর, স্লোভাকিয়া, স্লোভেনিয়া, স্পেন, সেন্ট মার্টেন, স্ট্যাটিয়া, সুইডেন, নেদারল্যান্ডস, সাইপ্রাস প্রজাতন্ত্র, ইউক্রেনের অধিকৃত অঞ্চল (ক্রিমিয়া সহ কিন্তু সীমাবদ্ধ নয়, দোনেৎস্কের অধিকৃত অংশ, লুহানস্ক, জাপোরিঝিয়া এবং খেরসন অঞ্চল), সংযুক্ত আরব আমিরাত, যুক্তরাজ্য, মার্কিন যুক্তরাষ্ট্রের নাগরিক এবং/অথবা বাসিন্দাদের নিবন্ধন, জমা এবং বাজি ধরা নিষিদ্ধ করে।',
      },
      {
        mark: '',
        content:
          '১৬. বেটিং কোম্পানি এতদ্বারা জানাচ্ছে যে সিঙ্গাপুরের আইনে সিঙ্গাপুরে উপস্থিত গ্রাহকদের জন্য দূরবর্তী জুয়া পরিষেবা প্রদান নিষিদ্ধ। এই ধারার উপরোক্ত বিধানগুলি সত্ত্বেও, বেটিং কোম্পানি বাধ্য নয় এবং করবে না: (i) ওয়েবসাইটে প্রদত্ত অনলাইন পরিষেবা ব্যবহার নিষিদ্ধ করার আইনের বিধানের অস্তিত্ব বা বিষয়বস্তু সম্পর্কে ক্লায়েন্টদের অবহিত করা, এবং (ii) এই ধরনের বিষয়ে পরামর্শ দেওয়া।',
      },
      {
        mark: '',
        content:
          '১৭. পক্ষগুলি একমত হয়েছে যে বলপ্রয়োগের পরিস্থিতি (অপ্রতিরোধ্য বলপ্রয়োগের পরিস্থিতি, যা পক্ষগুলির ইচ্ছার বাইরে), যার মধ্যে রয়েছে সরকারি কর্তৃপক্ষের পদক্ষেপ, যা এখানে বর্ণিত বাধ্যবাধকতা পূরণ করা পক্ষগুলির পক্ষে অসম্ভব করে তোলে, যেমন আগুন, বন্যা, অন্যান্য প্রাকৃতিক দুর্যোগ, পক্ষগুলি উল্লেখিত পরিস্থিতির সময়কালের জন্য তাদের বাধ্যবাধকতা থেকে অব্যাহতিপ্রাপ্ত। উল্লেখিত পরিস্থিতির প্রভাব ৩০ (ত্রিশ) ক্যালেন্ডার দিনের বেশি স্থায়ী হলে, প্রতিটি পক্ষের এই চুক্তিটি বাতিল করার অধিকার রয়েছে এবং এই ধরনের সমাপ্তির জন্য দায়ী থাকবে না, তবে শর্ত থাকে যে এটি অন্য পক্ষকে সমাপ্তির কমপক্ষে ১৫ (পনের) দিন আগে অবহিত করবে। বলপ্রয়োগের পর্যাপ্ত প্রমাণ হল চেম্বার অফ কমার্স কর্তৃক জারি করা একটি নথি। উল্লেখিত পরিস্থিতির উত্থান বেটিং কোম্পানির ক্লায়েন্টের গেমিং অ্যাকাউন্ট থেকে তহবিল ফেরত দিতে অস্বীকৃতির কারণ তৈরি করে না।',
      },
      {
        mark: '',
        content:
          '১৮. বেটিং কোম্পানি নিম্নলিখিত ব্যক্তিদের নিবন্ধন, জমা এবং বাজি ধরা প্রত্যাখ্যান করার অধিকার সংরক্ষণ করে:',
        list: [
          '১. কুরাসাওয়ের আর্থিক গোয়েন্দা ইউনিট (FIU) কর্তৃক অনুমোদিত দেশগুলির নাগরিক এবং/অথবা বাসিন্দা কারা;',
          '২. ফিনান্সিয়াল অ্যাকশন টাস্ক ফোর্স অন মানি লন্ডারিং (FATF) এর রিপোর্ট অনুসারে, যেসব রাজ্যের আইন ফিনান্সিয়াল অ্যাকশন টাস্ক ফোর্স অন মানি লন্ডারিং (FATF) এর প্রতিষ্ঠিত আন্তর্জাতিক মান মেনে চলে না এবং/অথবা যেসব রাজ্যের মানি লন্ডারিং এবং সন্ত্রাসী অর্থায়ন মোকাবেলার কৌশলে ফাঁক রয়েছে, তাদের নাগরিক এবং/অথবা বাসিন্দা কারা;',
          '৩. যাদের পূর্বে জুয়া খেলা থেকে বাদ দেওয়া হয়েছে অথবা স্বয়ং-বহিষ্কৃত করা হয়েছে;',
        ],
      },
      {
        mark: '',
        content: '১৯. বৌদ্ধিক সম্পত্তির অধিকার:',
        list: [
          '১. ওয়েবসাইটে থাকা সমস্ত ডিজাইন উপাদান, টেক্সট, গ্রাফিক্স, সঙ্গীত, শব্দ, ছবি, ভিডিও এবং তাদের নির্বাচন এবং পরিবেশন, সেইসাথে সফ্টওয়্যারের সংকলন, সোর্স কোড, সফ্টওয়্যার এবং অন্যান্য সমস্ত উপকরণ কপিরাইট এবং অন্যান্য মালিকানা অধিকারের সুরক্ষার অধীন যা হয় বেটিং কোম্পানির মালিকানাধীন অথবা তৃতীয় পক্ষের দ্বারা জারি করা লাইসেন্সের অধীনে বেটিং কোম্পানি দ্বারা ব্যবহৃত হয়, তাদের মালিকানাধীন। যে পরিমাণে কোনও উপকরণ ডাউনলোড বা মুদ্রণ করা যেতে পারে, সেই পরিমাণে এই উপকরণগুলি একটি একক ব্যক্তিগত কম্পিউটারেও ডাউনলোড করা যেতে পারে এবং ক্লায়েন্টের ব্যক্তিগত এবং অ-বাণিজ্যিক উদ্দেশ্যে পৃথক অংশগুলি মুদ্রণ করা যেতে পারে।',
          '2. কোনও অবস্থাতেই বেটিং কোম্পানির পরিষেবা ব্যবহার ক্লায়েন্টকে বেটিং কোম্পানি বা অন্য কোনও তৃতীয় পক্ষের মালিকানাধীন কোনও বৌদ্ধিক সম্পত্তির অধিকার (যেমন, কপিরাইট, জ্ঞান-উপাত্ত বা ট্রেডমার্ক) পাওয়ার অধিকার দেয় না।',
          '৩. ওয়েবসাইট বা এর যেকোনো বিভাগের অনুলিপি, সংরক্ষণ, প্রকাশ, ভাড়া, লাইসেন্স, বিক্রয়, বিতরণ, পরিবর্তন, সংযোজন, মুছে ফেলা, ধ্বংস বা ব্যাহত করার, এবং প্রত্যক্ষ বা পরোক্ষভাবে ওয়েবসাইটের কার্যক্রম ব্যাহত করার বা হস্তক্ষেপ করার (অথবা এই ধরনের পদক্ষেপের পরিকল্পনা করার) বা পরিবর্তন করার অধিকার ক্লায়েন্টের নেই, যদি না এটি নিয়ম অনুসারে ওয়েবসাইট দেখার বা ব্যবহারের সময় ঘটে।',
        ],
      },
      {
        mark: '',
        content:
          '২০. চুক্তির সমাপ্তির মুহূর্তটিকে এমন একটি মুহূর্ত হিসেবে বিবেচনা করা হয়, যখন বেটিং কোম্পানি ক্লায়েন্টকে সমস্ত চূড়ান্ত নিষ্পত্তির নিশ্চয়তার সাথে অবহিত করে।',
      },
      {
        mark: '',
        content:
          '২১. এখানে ক্লায়েন্টের কোন বাধ্যবাধকতা অর্পণ করা যাবে না। একজন ক্লায়েন্ট নিয়ম অনুসারে তার দায়িত্ব, সেইসাথে এখানে অর্পণ করা কোনও অধিকার বা বাধ্যবাধকতা অন্য কোনও ব্যক্তি বা সত্তাকে অর্পণ করতে পারবেন না।',
      },
      {
        mark: '',
        content:
          '২২. বেটিং কোম্পানি ক্লায়েন্টকে অবহিত না করেই নিয়মের অধীনে অধিকার এবং বাধ্যবাধকতা সম্পূর্ণ বা আংশিকভাবে বরাদ্দ বা স্থানান্তর করার অধিকার সংরক্ষণ করে, তবে শর্ত থাকে যে এই ধরনের কোনও স্থানান্তর একই শর্তে, অথবা ক্লায়েন্টের জন্য অনুকূল শর্তে হবে।',
      },
      {
        mark: '',
        content:
          '২৩. নিয়মাবলীর আওতায় না থাকা সকল বিষয়ে পক্ষগুলি কুরাসাওয়ের আইন দ্বারা পরিচালিত হবে।',
      },
    ],
  },
  {
    title: 'পক্ষগুলির অধিকার এবং বাধ্যবাধকতা',
    list: [
      {
        mark: '',
        content: '২৪. বেটিং কোম্পানি:',
        list: [
          '১. ক্লায়েন্টকে নিবন্ধন করুন এবং তাকে গেমিং অ্যাকাউন্টের একটি অনন্য নম্বর বরাদ্দ করুন।',
          '2. ক্লায়েন্টকে একটি গেমিং অ্যাকাউন্ট পরিচালনা করার ক্ষমতা প্রদান করুন।',
          '৩. নিবন্ধনের সময় প্রাপ্ত ক্লায়েন্টের তথ্য, বাজি ধরা, ক্লায়েন্টের গেমিং ফলাফল এবং তার সাথে অর্থপ্রদানের নিষ্পত্তি এবং ৩. ব্যক্তিগত তথ্য সুরক্ষা আইন, কুরাকাও ২০১৩ অনুসারে অন্যান্য তথ্যের গোপনীয়তা বজায় রাখুন।',
          '৪. ক্লায়েন্টকে ইমেল এবং টেলিফোন "হট লাইন" এর মাধ্যমে চব্বিশ ঘন্টা প্রযুক্তিগত সহায়তা প্রদান করুন।',
        ],
      },
      {
        mark: '',
        content: '২৫. বেটিং কোম্পানির অধিকার আছে:',
        list: [
          '১. ক্লায়েন্ট যদি নিয়মের বিধানগুলি পূরণ করতে ব্যর্থ হন তবে পরিষেবার বিধান স্থগিত করুন।',
          '২. একতরফাভাবে নিয়ম সংশোধন করুন। বেটিং কোম্পানি নিয়ম সংশোধনের বিষয়ে ক্লায়েন্টকে অতিরিক্ত নোটিশ পাঠায় না। ক্লায়েন্ট নিজেই প্রাসঙ্গিক সংশোধনগুলি অনুসরণ করতে বাধ্য।',
        ],
      },
      {
        mark: '',
        content: '২৬. ক্লায়েন্ট:',
        list: [
          '১. নিজে নিয়মগুলি পড়ুন এবং সমস্ত অস্পষ্ট বিষয়ে একটি বিস্তৃত ব্যাখ্যা পান।',
          '২. তার গেমিং অ্যাকাউন্টের নম্বর এবং এতে অ্যাক্সেস পাসওয়ার্ড গোপন রাখুন। সঠিক ইনপুট প্লেয়ারের নাম এবং পাসওয়ার্ড এবং/অথবা অ্যাকাউন্ট নম্বর ব্যবহার করে করা সমস্ত লেনদেন বৈধ বলে বিবেচিত হবে, তা ক্লায়েন্ট কর্তৃক অনুমোদিত কিনা তা বিবেচনা না করেই এবং ক্লায়েন্ট তার ব্যবহারকারীর নাম, পাসওয়ার্ড বা অ্যাকাউন্ট নম্বর অন্য কাউকে সরবরাহ করলে বেটিং কোম্পানি কোনও দাবির জন্য দায়ী থাকবে না।',
          '৩. ক্লায়েন্টের কর আবাসস্থলের দেশের আইন অনুসারে এবং/অথবা বিজয়ী হওয়ার সময় ক্লায়েন্ট যে দেশে অবস্থান করছেন, সেই দেশের আইন অনুসারে স্বাধীনভাবে এমন পদক্ষেপ গ্রহণ করা, যা বেটিং কোম্পানি থেকে প্রাপ্ত রাজস্ব থেকে কর বা অন্যান্য বাধ্যতামূলক চার্জ পরিশোধের ক্ষেত্রে প্রযোজ্য হতে পারে। বেটিং কোম্পানি ক্লায়েন্টকে আইনের এই ধরনের বিধানের অস্তিত্ব বা বিষয়বস্তু সম্পর্কে অবহিত করবে না এবং এই ধরনের বিষয়ে পরামর্শ দেবে না।',
        ],
      },
      {
        mark: '',
        content: '২৭. ক্লায়েন্টের অধিকার রয়েছে:',
        list: [
          '১. নিয়ম অনুযায়ী বেটিং কোম্পানির কাছ থেকে বাজির সম্পূর্ণ তালিকা গ্রহণ করুন।',
          '২. নিবন্ধিত ইমেল ঠিকানা থেকে পাঠানো ইমেলের মাধ্যমে আমাদের আগে থেকে অবহিত করার পর এবং ওয়েবসাইটে অনুমোদনের পর প্রতি ৯০ দিন অন্তর একবার বেটিং কোম্পানির সাথে একতরফাভাবে খেলা প্রত্যাখ্যান করুন। চূড়ান্ত নিষ্পত্তির পরে অ্যাকাউন্টটি ব্লক করা হবে। ব্যতিক্রমী ক্ষেত্রে, ক্লায়েন্ট খেলা প্রত্যাখ্যান করার জন্য পুনরায় অনুরোধ জমা দিতে পারেন, তবে পূর্ববর্তী অনুরোধের ত্রিশ (৩০) দিনের কম নয়। বেটিং কোম্পানি আবার অ্যাকাউন্টটি ব্লক করতে অস্বীকার করার অধিকার সংরক্ষণ করে।',
          '৩. গেমিং অ্যাকাউন্টের সর্বোচ্চ বাজি এবং ব্যয় করা তহবিলের সীমা নির্ধারণ করুন অথবা নিয়ম দ্বারা নির্ধারিত পদ্ধতিতে নিজস্ব বিবেচনার ভিত্তিতে খেলা থেকে স্ব-বর্জন জমা দিন।',
        ],
      },
      {
        mark: '',
        content:
          '২৮. ক্লায়েন্টরা গ্যারান্টি দেয় যে বেটিং কোম্পানি থেকে অনলাইন পরিষেবা গ্রহণের মুহূর্তে:',
        list: [
          '১. এই বিধিমালার ১৪-১৫ ধারায় উল্লেখিত কোনও দেশের ভূখণ্ডে তিনি শারীরিকভাবে উপস্থিত নন;',
          '২. তিনি ক্লায়েন্টের নাগরিকত্বের দেশের এবং/অথবা বেটিং কোম্পানির কাছ থেকে পরিষেবা গ্রহণের সময় ক্লায়েন্ট যে দেশের অঞ্চলে উপস্থিত আছেন সেই দেশের আইন মেনে চলছেন, ওয়েবসাইটে প্রদত্ত পরিষেবা গ্রহণের অধিকার বা নিষেধাজ্ঞার ক্ষেত্রে।',
        ],
      },
    ],
  },
  {
    title: 'বাজি গ্রহণের শর্তাবলী',
    list: [
      {
        mark: '',
        content:
          '২৯. বাজিগুলি লাইনের উপর ভিত্তি করে গৃহীত হয়, অর্থাৎ, বেটিং কোম্পানি কর্তৃক প্রদত্ত ফলাফলের জন্য সম্ভাব্য সময়ে আসন্ন ইভেন্টগুলির তালিকা।',
      },
      {
        mark: '',
        content:
          "৩০. যেকোনো বাজির পরে লাইন পরিবর্তন (প্রতিবন্ধকতা, বিজয়ীর ব্যবধান, মোট সংখ্যা, পার্লে'র সীমাবদ্ধতা, সর্বোচ্চ বাজির পরিমাণ এবং অন্যান্য) ঘটতে পারে, তবে ইতিমধ্যে রাখা বাজির শর্তাবলী পরিবর্তন ছাড়াই থাকবে। অ্যাকাউন্ট ব্যালেন্সের চেয়ে বেশি না হওয়া পরিমাণের জন্য বাজি গ্রহণ করা হবে।",
      },
      {
        mark: '',
        content:
          '৩১. ইভেন্ট শুরু হওয়ার আগে বাজি গ্রহণ করা হবে। ইভেন্ট শুরুর পরে যে বাজি ধরা হবে তা বৈধ নয় এবং এই ধরনের বাজি ফেরত দেওয়া হবে। এই বাজিগুলি পার্লে থেকে সরিয়ে দেওয়া হবে। ব্যতিক্রমগুলি ইভেন্ট চলাকালীন তথাকথিত লাইভ বাজি। এই বাজিগুলি বৈধ এবং শুধুমাত্র তখনই ফেরত দেওয়া হবে যদি কোনও কারণে ইভেন্ট শেষ হওয়ার পরে বাজি ধরা হয়। লাইভ ইভেন্টের অগ্রগতিতে ফলাফল আপডেট শুধুমাত্র তথ্যের উদ্দেশ্যে। ভুলভাবে তালিকাভুক্ত ফলাফল বাজি বাতিল করার ভিত্তি হতে পারে না। লাইভ ইভেন্ট চলাকালীন ফলাফলের সঠিকতার জন্য বেটিং কোম্পানি দায়ী নয়।',
      },
      {
        mark: '',
        content:
          '৩২. লাইনে উল্লেখিত ইভেন্ট শুরুর তারিখ এবং সময় শুধুমাত্র তথ্যবহুল। ইভেন্ট শুরুর আগে যদি বাজি ধরা হয়ে থাকে, তাহলে ভুল তারিখ বাজি ফেরত দেওয়ার কোনও কারণ নয়। বাজি নিষ্পত্তির জন্য, ইভেন্ট শুরুর প্রকৃত সময় ব্যবহার করা হয়। এই সময়টি প্রতিযোগিতা, ম্যাচ ইত্যাদি পরিচালনাকারী সংস্থার অফিসিয়াল নথি (তথ্য সংগ্রহের সময় বেটিং কোম্পানি দ্বারা উল্লেখিত ওয়েবসাইট) অনুসারে নির্ধারিত হয়।',
      },
      {
        mark: '',
        content:
          '৩৩. যেসব ইভেন্টে বাজি ধরা হয়েছে, সেইসব ইভেন্টের খেলোয়াড়দের পদবি, দলের নাম এবং শহরের নামের ভুল বানানের জন্য বেটিং কোম্পানি কোনও দায় স্বীকার করে না।',
      },
      {
        mark: '',
        content:
          '৩৪. বেটিং লাইন তৈরি এবং প্রকাশের সময় কর্মীদের ভুলের ক্ষেত্রে, অথবা বেটিং লাইন নির্ধারণকারী কম্পিউটার সফটওয়্যারে কোনও স্পষ্ট ব্যর্থতা (অডসে স্পষ্ট ভুল, বিভিন্ন অবস্থানে অডসে অমিল ইত্যাদি), এই নিয়ম অনুসারে প্রদত্ত শর্ত লঙ্ঘন করে বেটিং কোম্পানির কর্মচারীর প্রতারণামূলক কর্মকাণ্ডের ক্ষেত্রে, বেটিং কোম্পানির একতরফাভাবে সমাপ্ত চুক্তি (ইভেন্ট শুরুর আগে বা পরে রাখা বাজি সহ, যা ভুলের সাথে সম্পর্কিত) অবৈধ স্বীকৃতি দেওয়ার, এই ধরনের চুক্তির অধীনে বাধ্যবাধকতা পূরণ করতে অস্বীকার করার এবং ক্লায়েন্টকে বাজি ফেরত দেওয়ার অধিকার রয়েছে।',
      },
      {
        mark: '',
        content:
          '৩৫. ক্লায়েন্ট বাজি ধরার পর এবং যাচাইকরণ (সাইটে একটি নোট এবং বাজির নম্বর) পাওয়ার পর বাজি পরিবর্তন বা বাতিল করা যাবে না।',
      },
      {
        mark: '',
        content:
          '৩৬. যদি সার্ভারে বাজি নিবন্ধিত থাকে, তাহলে সংযোগ ব্যর্থতা এবং যোগাযোগের অন্যান্য প্রযুক্তিগত ত্রুটির কারণে বাজি পরিবর্তন বা বাতিল করার কোনও কারণ নেই।',
      },
      {
        mark: '',
        content:
          '৩৭. পাসওয়ার্ড হারানো কোনও বাজি পরিবর্তন বা বাতিল করার বা পেমেন্ট অনুরোধ বাতিল করার কোনও কারণ নয়।',
      },
      {
        mark: '',
        content:
          '৩৮. প্রতিটি ক্লায়েন্ট একটি করে গেমিং অ্যাকাউন্টের অধিকারী, যদি না কেস-বাই-কেস ভিত্তিতে বেটিং কোম্পানির প্রশাসক কর্তৃক অন্যথায় অনুমোদিত হয়। এই নিয়মের যেকোনো ব্যতিক্রমের জন্য ক্লায়েন্টকে বেটিং কোম্পানির প্রশাসকের কাছ থেকে আগে থেকেই অনুমতি নিতে হবে। ঘটনার পরে করা আবেদনগুলি লঙ্ঘন হিসাবে বিবেচিত হবে।',
      },
      {
        mark: '',
        content:
          '৩৯. ক্লায়েন্ট অন্য কাউকে তার গেমিং অ্যাকাউন্ট ব্যবহারের অনুমতি দিতে পারবেন না।',
      },
      {
        mark: '',
        content: '৪০. বেটিং কোম্পানির অধিকার রয়েছে:',
        list: [
          '১. কারণ ব্যাখ্যা এবং পূর্ব লিখিত নোটিশ ছাড়াই কোনও ব্যক্তির কাছ থেকে বাজি গ্রহণে সীমাবদ্ধতা প্রয়োগ করুন বা প্রত্যাখ্যান করুন;',
          '2. ক্লায়েন্টের পক্ষ থেকে প্রতারণামূলক কর্মকাণ্ডের সন্দেহ হলে, এই ধরনের ক্লায়েন্টের করা সমস্ত বাজি বাতিল করুন, আমানত ফেরত দিন এবং গেম অ্যাকাউন্ট বন্ধ করুন;',
          '৩. ক্লায়েন্টের অনুরোধে ক্লায়েন্টের গেম অ্যাকাউন্টটি পুনরুদ্ধারের সম্ভাবনা ছাড়াই বন্ধ করুন।',
        ],
      },
      {
        mark: '',
        content:
          'বাজি গ্রহণ করতে অস্বীকার করার এবং/অথবা গেম অ্যাকাউন্ট বন্ধ করার সিদ্ধান্তটি এই নিয়মগুলির ভিত্তিতে বেটিং কোম্পানির নিজস্ব বিবেচনার ভিত্তিতে নেওয়া হয়, ক্লায়েন্টের বাজির ইতিহাস এবং একটি নির্দিষ্ট পরিস্থিতির পরিস্থিতি বিবেচনা করে।',
      },
    ],
  },
  {
    title: 'বিশেষ শর্তাবলী',
    list: [
      {
        mark: '',
        content: '৪১. যদি ঘটনাটি:',
        list: [
          '১. নির্ধারিত তারিখে অনুষ্ঠিত হয়নি এবং বেটস্লিপে উল্লেখিত শুরুর সময় থেকে ৩৬ ঘন্টারও বেশি সময় ধরে স্থগিত করা হয়েছিল - এই ইভেন্টের সমস্ত বাজি ১ অডসে নিষ্পত্তি করা হবে (যদি না এই ধরণের খেলার নিয়মে অন্যথা বলা থাকে)।',
          '2. বেটস্লিপে উল্লেখিত শুরুর সময় থেকে 12 ঘন্টার মধ্যে বাধাগ্রস্ত হয়েছিল এবং সম্পন্ন হয়নি - বাধার সময় দ্বারা নির্ধারিত ফলাফল সহ ফলাফলের উপর সমস্ত বাজি এই ফলাফল অনুসারে নিষ্পত্তি করা হয়, এবং নির্ধারিত ফলাফল ছাড়াই ফলাফলের উপর বাজিগুলি অডস 1 এ নিষ্পত্তি করা হয় (যদি না খেলাধুলার নিয়মে অন্যথা বলা থাকে)।',
        ],
      },
      {
        mark: '',
        content:
          '৪২. যদি ম্যাচটি নিরপেক্ষ মাঠে স্থানান্তরিত হয়, তাহলে বাজির পরিমাণ অপরিবর্তিত থাকবে। যদি ম্যাচটি প্রতিপক্ষের মাঠে স্থানান্তরিত হয়, তাহলে বাজির পরিমাণ ফেরত দেওয়া হবে এবং বাজিগুলি পার্লে থেকে সরিয়ে দেওয়া হবে। যদি ম্যাচটি একই শহরের অন্য কোনও মাঠে স্থানান্তরিত হয়, তাহলে বাজির পরিমাণ অপরিবর্তিত থাকবে এবং খেলার মাঠ যাই হোক না কেন, তাদের টাকা ফেরত দেওয়া হবে না।',
      },
      {
        mark: '',
        content:
          '৪৩. যদি ফলাফল পরিবর্তন বা বাতিল করা হয় (প্রতিবাদ, ডোপিং, ইত্যাদি), তাহলে মূল ফলাফলটি বাজিতেই থাকবে।',
      },
      {
        mark: '',
        content:
          '৪৪. যদি একাধিক খেলোয়াড় (দল) কে প্রতিযোগিতার বিজয়ী হিসেবে ঘোষণা করা হয়, তাহলে এই খেলোয়াড়দের (দল) জয়ের উপর রাখা বাজি ১ এর ব্যবধানে নিষ্পত্তি করা হবে।',
      },
      {
        mark: '',
        content:
          '৪৫. ইভেন্টের পরে বেটিং কোম্পানি অফিসিয়াল রেকর্ড এবং অন্যান্য তথ্যের উৎসের ভিত্তিতে প্রকৃত ফলাফল ঘোষণা করে। বিতর্কিত পরিস্থিতিতে, যখন একই ইভেন্টের জন্য বিভিন্ন ফলাফল বিভিন্ন উৎস থেকে তাদের স্পষ্ট ভুল সহ পোস্ট করা হয়, তখন বেটিং কোম্পানি দ্বারা বাজি নিষ্পত্তির ফলাফল নির্ধারণের চূড়ান্ত সিদ্ধান্ত নেওয়া হয়।',
      },
      {
        mark: '',
        content:
          '৪৬. যদি ধরে নেওয়ার কারণ থাকে যে ইভেন্টের ফলাফল জানা যাওয়ার পরে বাজি ধরা হয়েছিল, অথবা নির্বাচিত খেলোয়াড়/দল উল্লেখযোগ্য সুবিধা অর্জনের পরে (যেমন, স্কোরের সুবিধা, খেলোয়াড়কে বিদায় দেওয়া বা প্রতিস্থাপন ইত্যাদি), তাহলে বেটিং কোম্পানি এই বাজি বাতিল করার (অর্থ ফেরত দেওয়ার) অধিকার সংরক্ষণ করে, জয় এবং পরাজয় উভয় ক্ষেত্রেই।',
      },
      {
        mark: '',
        content:
          '৪৭. বেটিং কোম্পানি লাইভ ইভেন্টের বাজি নিষ্পত্তির জন্য খেলার প্রকৃত গতিপথ সম্পর্কে নিজস্ব তথ্য ব্যবহার করে। যদি কোনও কারণে (যেমন সম্প্রচারের ক্ষতি, তথ্যের উৎসে ফলাফলের অভাব ইত্যাদি) ইভেন্টের ফলাফল নির্ধারণ করা না যায়, তাহলে এই ইভেন্টগুলি অডস ১-এ নিষ্পত্তি করা হবে।',
      },
      {
        mark: '',
        content:
          '৪৮. ক্লায়েন্টের অবশ্যই পরীক্ষা করা উচিত যে তার বেটিং স্লিপ নিয়ম অনুসারে পূরণ করা হয়েছে। যদি কোনও বেটিং স্লিপ ভুলভাবে পূরণ করা হয়, কারণ বা ত্রুটি নির্বিশেষে, বেটিং কোম্পানি বাজি ফেরত দেওয়ার এবং বাজি বাতিল করার অধিকার সংরক্ষণ করে।',
      },
      {
        mark: '',
        content:
          '৪৯. যদি কোনও ক্লায়েন্ট ভুলভাবে প্রবেশ করানো ফলাফলের কারণে বাজির পুনর্মূল্যায়নের ফলে ঋণাত্মক ব্যালেন্সের সম্মুখীন হয়, তাহলে গেমিং অ্যাকাউন্টটি সাময়িকভাবে ব্লক করা হবে যতক্ষণ না ক্লায়েন্ট ঋণাত্মক ব্যালেন্সের সমান বা তার বেশি পরিমাণ জমা করে। এটি করতে ব্যর্থ হলে বেটিং কোম্পানি ক্লায়েন্টের কাছ থেকে আরও বাজির গ্রহণযোগ্যতা স্থগিত করতে পারে। এটি মনে রাখা গুরুত্বপূর্ণ যে পুনর্মূল্যায়নের আগে রাখা সমস্ত বাজি বৈধ থাকবে।',
      },
      {
        mark: '',
        content:
          '৫০. বিতর্কিত বিষয় সম্পর্কিত অভিযোগ ইভেন্টের ফলাফল নিবন্ধনের ১০ দিনের মধ্যে ইমেল আবেদনের মাধ্যমে (spinbajifeedback@gmail.com ঠিকানায় পাঠানো হবে) জমা দিতে হবে। ১০ দিনের পরে, কোনও অভিযোগ গ্রহণ করা হবে না। অনন্য এবং অভূতপূর্ব বিতর্কিত পরিস্থিতিতে, চূড়ান্ত সিদ্ধান্ত বেটিং কোম্পানির উপর নির্ভর করে।',
      },
      {
        mark: '',
        content:
          '৫১. বেটিং কোম্পানি সকল অভিযোগ এবং বিরোধ অত্যন্ত গুরুত্ব সহকারে বিবেচনা করে এবং সকল অভিযোগ এবং বিরোধের সুষ্ঠু, স্বচ্ছ এবং সময়োপযোগী সমাধান নিশ্চিত করার জন্য সম্পূর্ণরূপে প্রতিশ্রুতিবদ্ধ। গ্রাহক সহায়তা দলের কাছে সরাসরি অভিযোগ জমা দিতে ইচ্ছুক যেকোনো ক্লায়েন্টকে অভিযোগকারীর পরিচয় এবং অভিযোগের কারণ সম্পর্কে স্পষ্ট এবং দ্ব্যর্থহীন তথ্য প্রদান করতে হবে। বেটিং কোম্পানির দাবি বিবেচনা করা হবে কেবল তখনই যদি ক্লায়েন্টের কাছে বাজির অর্থ প্রদানের বিষয়টি নিশ্চিত করার জন্য প্রাসঙ্গিক আর্থিক নথি থাকে।',
      },
      {
        mark: '',
        content:
          '৫২. গ্রাহক সহায়তা দল অভিযোগ জমা দেওয়ার তারিখ থেকে ত্রিশ (৩০) দিনের মধ্যে ক্লায়েন্টকে অভিযোগের বিষয়ে একটি পূর্ণাঙ্গ এবং বিস্তারিত প্রতিক্রিয়া প্রদানের প্রতিশ্রুতি দেয়। তবে, যেসব ক্ষেত্রে অভিযোগের বিষয়টি জটিল প্রকৃতির এবং গ্রাহক সহায়তা দল কর্তৃক গভীর তদন্তের প্রয়োজন হয়, সেসব ক্ষেত্রে এটি আরও বেশি সময় নিতে পারে। এছাড়াও, যেখানে সমাধান ক্লায়েন্টের আরও তথ্য সরবরাহের উপর নির্ভর করে, সেখানে সমস্ত প্রয়োজনীয় তথ্য জমা না দেওয়া পর্যন্ত ত্রিশ (৩০) দিন সময়কাল বাড়ানো হবে।',
      },
      {
        mark: '',
        content:
          '৫৩. ক্লায়েন্ট সুরক্ষা এবং সর্বোত্তম ক্লায়েন্ট কেয়ার পরিষেবা নিশ্চিত করার জন্য, বেটিং কোম্পানি, ক্লায়েন্ট এবং বেটিং কোম্পানির মধ্যে সমস্ত টেলিফোন কথোপকথন, ইমেল এবং চিঠিপত্র রেকর্ড করে এবং/অথবা পর্যবেক্ষণ করে। বেটিং কোম্পানি ক্লায়েন্টের অভিযোগের সাথে সম্পর্কিত সমস্ত তথ্য এবং ব্যক্তিগত তথ্য সংরক্ষণ করার অধিকার সংরক্ষণ করে, যতদূর এটি প্রয়োজনীয় বা আইন দ্বারা অনুমোদিত। গোপনীয়তা নীতিতে প্রদত্ত বেটিং কোম্পানির কাছে থাকা ব্যক্তিগত তথ্য অ্যাক্সেস করার অধিকার ক্লায়েন্টের রয়েছে।',
      },
      {
        mark: '',
        content:
          '৫৪. ক্লায়েন্টের তখনই কমিশনারের (কুরাকাও লাইসেন্স) সাথে যোগাযোগ করা উচিত যখন তিনি বিশ্বাস করেন যে বেটিং কোম্পানি লাইসেন্স লঙ্ঘন করছে। পেমেন্ট, ব্লক করা অ্যাকাউন্ট, বিলম্ব, ভাঙা বৈশিষ্ট্য ইত্যাদি বিষয়ে বেটিং কোম্পানির সাথে সমস্ত বিরোধ প্রথমে সরাসরি বেটিং কোম্পানির সাথে তোলা উচিত। যে ক্লায়েন্ট কমিশনারের কাছে অভিযোগ পাঠাতে চান তিনি নিয়ন্ত্রকের ইমেল ঠিকানায় একটি ইমেলের মাধ্যমে এটি পাঠাতে পারেন। ক্লায়েন্টকে ওয়েবসাইটের নীচে কুরাকাও লোগোতে ক্লিক করে লাইসেন্সটি যাচাই করতে হবে যেখানে তিনি নিয়ন্ত্রকের যোগাযোগের বিবরণ পাবেন।',
      },
    ],
  },
  {
    title: 'আর্থিক সীমাবদ্ধতা',
    list: [
      {
        mark: '',
        content:
          '৫৫. পার্লেতে সর্বোচ্চ অডস ২০০০। যদি অডস ২০০০-এর বেশি হয়, তাহলে জয়ের পরিমাণ গণনা করা হবে যেন অডস ঠিক ২০০০। তবে, জয়ের পরিমাণ একটি বাজির সর্বোচ্চ জয়ের চেয়ে বেশি হবে না।',
      },
      {
        mark: '',
        content:
          '৫৬. প্রতিটি ইভেন্টের জন্য সর্বোচ্চ বাজির পরিমাণ ইভেন্ট এবং খেলার উপর নির্ভর করে। প্রতিটি ইভেন্ট এবং বাজির ফর্মের জন্য বেটিং কোম্পানি দ্বারা সর্বোচ্চ বাজির পরিমাণ পৃথকভাবে নির্ধারণ করা হবে এবং লিখিত নোটিশ ছাড়াই এটি পরিবর্তন করা যেতে পারে। বেটিং কোম্পানি নির্দিষ্ট ইভেন্টের জন্য সর্বোচ্চ বাজির পরিমাণ সীমিত করার এবং নোটিশ ছাড়াই পৃথক ক্লায়েন্টদের জন্য বাজির সীমা পরিবর্তন করার অধিকার সংরক্ষণ করে।',
      },
      {
        mark: '',
        content:
          '৫৭. গেমিং অ্যাকাউন্টের মুদ্রায় একটি বাজির সর্বোচ্চ পরিশোধ ১,০০০,০০০ মার্কিন ডলারের সমতুল্য।',
      },
      {
        mark: '',
        content:
          '৫৮. টাকা তোলার জন্য, ক্লায়েন্টকে জমাকৃত পরিমাণের কমপক্ষে সত্তর (৭০) শতাংশ বাজি ধরতে হবে।',
      },
    ],
  },
  {
    title: 'অতিরিক্ত জিজ্ঞাসা',
    list: [
      {
        mark: '',
        content:
          '৫৯. যদি আপনি বিভাগে উল্লেখিত সর্বোচ্চ পরিমাণের চেয়ে বেশি পরিমাণে বাজি ধরতে চান, তাহলে আপনি "ওভারআস্ক" হিসেবে আপনার বাজি ধরতে পারেন। এটি করার জন্য, নিম্নলিখিত শর্তগুলি পূরণ করতে হবে:',
        list: [
          '১. আপনার অ্যাকাউন্টে থাকা পরিমাণ বিভাগে নির্দেশিত সর্বোচ্চ পরিমাণের বেশি হতে হবে।',
          '২. গেমিং অ্যাকাউন্টের মুদ্রায় "ওভারাস্ক" এর সর্বনিম্ন পরিমাণ ১০০ মার্কিন ডলারের সমতুল্য।',
          '৩. আপনার বাজি অবশ্যই সিঙ্গেল অথবা পার্লে হতে হবে।',
          '৪. "ওভারআস্ক" বিভাগে "লাইভ" ইভেন্টের উপর বাজি অন্তর্ভুক্ত নয়।',
          '৫. ইভেন্ট শুরুর ৫ মিনিটের মধ্যে "ওভারাস্ক" অনুরোধ করার বিকল্প আর উপলব্ধ থাকবে না।',
        ],
      },
      {
        mark: '',
        content:
          '৬০. যদি "ওভারাস্ক" প্লেসমেন্টের উপরোক্ত সমস্ত শর্ত পূরণ করা হয়, তাহলে এই বাজিটি গ্রহণের সম্ভাবনার জন্য বেটিং কোম্পানি দ্বারা বিবেচনা করা হবে। ৫ মিনিটের মধ্যে সিদ্ধান্ত নেওয়া হবে। আপনার বাজি সম্পূর্ণরূপে গৃহীত বা সম্পূর্ণরূপে প্রত্যাখ্যাত হবে। বাজির পর্যালোচনা এবং এটি সম্পর্কে নেওয়া সিদ্ধান্ত "অ্যাকাউন্ট ইতিহাস" পৃষ্ঠায় দেখানো হবে। দয়া করে মনে রাখবেন যে "ওভারাস্ক" প্রত্যাখ্যানের ক্ষেত্রে, আপনি নির্বাচিত বিভাগের সীমা অনুসারে সর্বোচ্চ বাজির পরিমাণ রাখতে পারেন।',
      },
      {
        mark: '',
        content:
          '৬১. "ওভারাস্ক" এর সর্বোচ্চ পরিশোধ ১,০০০,০০০ মার্কিন ডলারের সমতুল্য।',
      },
    ],
  },
  {
    title: 'গেমিং অ্যাকাউন্ট খোলা এবং তহবিল জমা করার নিয়ম',
    list: [
      {
        mark: '',
        content: '62. একটি গেমিং অ্যাকাউন্ট খুলতে, ক্লায়েন্টকে অবশ্যই:',
        list: [
          '১. ওয়েবসাইটের সংশ্লিষ্ট বিভাগে সার্ভারে নিবন্ধন করুন;',
          '2. বাজির গ্রহণযোগ্যতা বিন্দুতে, ব্যাংক লেনদেনে বা ইলেকট্রনিক অর্থপ্রদানের পদ্ধতিতে গেমিং অ্যাকাউন্টে তহবিল জমা করুন (আমানত তৈরিতে আরও বিস্তারিত)।',
        ],
      },
      {
        mark: '',
        content:
          '63. ওয়েবসাইটে নিবন্ধন করার সময় ক্লায়েন্ট গেমিং অ্যাকাউন্টের পাসওয়ার্ড প্রবেশ করান। এই পাসওয়ার্ডে যেকোনো অক্ষর থাকতে পারে এবং অনুমোদন প্রক্রিয়ার পরে ক্লায়েন্ট সাইটে যেকোনো সময় এটি পরিবর্তন করতে পারেন।',
      },
      {
        mark: '',
        content: '৬৪. গেমিং অ্যাকাউন্টের সমস্ত লেনদেন ভারতীয় রুপিতে করা হবে।',
      },
      {
        mark: '',
        content:
          '৬৫. বেটিং কোম্পানি গেমিং লেনদেনের জন্য ক্লেইন্টসকে ক্রেডিট দেয় না।',
      },
      {
        mark: '',
        content:
          '৬৬. ব্যাংক ট্রান্সফার বা ইলেকট্রনিক পেমেন্ট পদ্ধতির মাধ্যমে একবার আমানত করা হয়ে গেলে, পেমেন্ট পরিষেবা প্রদানকারী বেটিং কোম্পানিকে সফল আমানতের বিষয়ে অবহিত করার সাথে সাথেই গেমিং অ্যাকাউন্টটি সার্ভারে জমা হয়ে যাবে। গেমিং অ্যাকাউন্টে জমা করা তহবিল জমা করার গতি ডিপোজিটের তারিখ এবং সময়, নির্বাচিত পেমেন্ট পরিষেবা প্রদানকারী, ক্লায়েন্ট কর্তৃক নির্বাচিত আমানত পদ্ধতি এবং অন্যান্য প্রাসঙ্গিক পরিস্থিতির উপর নির্ভর করে। ডিপোজিট করার এক ঘন্টার মধ্যে যদি গেমিং অ্যাকাউন্টে অর্থ জমা না হয়, তাহলে ক্লায়েন্টকে ওয়েবসাইটে উপলব্ধ সহায়তা চ্যানেলগুলির মাধ্যমে (spinbajifeedback@gmail.com) বেটিং কোম্পানির সহায়তার কাছে একটি আবেদন জমা দিতে হবে।',
      },
      {
        mark: '',
        content:
          '৬৭. অর্থপ্রদানের তথ্য বলতে বেটিং কোম্পানির অ্যাকাউন্টে তহবিলের প্রকৃত প্রাপ্তি বোঝাবে।',
      },
      {
        mark: '',
        content:
          '৬৮. ক্যাশ ডেস্কে, ব্যাংক ট্রান্সফারের মাধ্যমে অথবা ইলেকট্রনিক পেমেন্ট পদ্ধতির মাধ্যমে জমা করার পর, গেমিং অ্যাকাউন্টটি সার্ভারে জমা হবে:',
        list: [
          '১. বেটিং কোম্পানির বেট গ্রহণ পয়েন্টের মাধ্যমে তহবিল জমা দেওয়ার ৩০ মিনিটের মধ্যে;',
          '২. ইলেকট্রনিক পেমেন্ট পদ্ধতির মাধ্যমে অ্যাকাউন্টে তহবিল জমা দেওয়ার ৩০ মিনিটের মধ্যে;',
          '৩. ব্যাংক ট্রান্সফার এবং ক্রেডিট কার্ড ডিপোজিটের মাধ্যমে Mystech Entertainment BV অ্যাকাউন্টে অর্থের প্রকৃত প্রাপ্তির পরে।',
        ],
      },
      {
        mark: '',
        content:
          '৬৯. অর্থ স্থানান্তরের সমস্ত খরচ ক্লায়েন্ট দ্বারা বহন করা হয়। বিরোধ এড়াতে, স্থানান্তরের রসিদ ৩ বছরের জন্য সংরক্ষণ করুন।',
      },
      {
        mark: '',
        content:
          '৭০. যদি তৃতীয় পক্ষের পদক্ষেপ বা বলপ্রয়োগের ঘটনা (অনুমোদন কেন্দ্র, যোগাযোগ চ্যানেল ইত্যাদি সহ) এর মতো নিয়ন্ত্রণের বাইরের কারণগুলির কারণে, ক্লায়েন্ট কর্তৃক প্রত্যাশিত বা বেটিং কোম্পানি কর্তৃক নির্দিষ্ট সময়সীমার মধ্যে গেমিং অ্যাকাউন্টে ক্রেডিট না করা হয়, তাহলে বেটিং কোম্পানির কোনও দায়বদ্ধতা থাকবে না।',
      },
      {
        mark: '',
        content:
          '৭১. ক্রেডিট/ডেবিট কার্ড ব্যবহার করে গেমিং অ্যাকাউন্টে তহবিল জমা করার জন্য, ক্রেডিট কার্ডের সাথে সম্পর্কিত ব্যক্তিগত তথ্য অবশ্যই গেমিং অ্যাকাউন্টে নিবন্ধিত ব্যক্তিগত তথ্যের সাথে মিলতে হবে।',
      },
      {
        mark: '',
        content:
          '৭২. ক্রেডিট/ডেবিট কার্ড এবং/অথবা ই-ওয়ালেটের মাধ্যমে গেমিং অ্যাকাউন্টে অর্থ জমা করার জন্য, ক্লায়েন্টকে গেমিং অ্যাকাউন্টের মুদ্রায় একটি ব্যাংক অ্যাকাউন্ট থাকতে হবে না। আন্তর্জাতিক পেমেন্ট সিস্টেমগুলি স্বাধীনভাবে এবং স্বয়ংক্রিয়ভাবে যেকোনো অর্থ প্রদানকে বর্তমান আন্তঃব্যাংক হারের সাথে অন্য যেকোনো মুদ্রা থেকে গেমিং অ্যাকাউন্টের মুদ্রায় রূপান্তর করে।',
      },
      {
        mark: '',
        content:
          '৭৩. অনলাইন লেনদেনের জন্য পেমেন্ট কার্ড সক্রিয় থাকতে হবে। যদি আপনার কার্ডটি বর্তমানে অনলাইন ব্যবহারের জন্য অনুমোদিত না হয়, তাহলে যেকোনো বিধিনিষেধ অপসারণের জন্য অনুগ্রহ করে আপনার ব্যাংকের সাথে যোগাযোগ করুন।',
      },
      {
        mark: '',
        content:
          '৭৪. বেটিং কোম্পানির গেমিং অ্যাকাউন্টে তহবিল জমা করার সময় এবং কমিশন পরিবর্তিত হতে পারে। লেনদেনের বর্তমান শর্তাবলী সর্বদা "আমানত তৈরি" পৃষ্ঠায় প্রদর্শিত হবে।',
      },
      {
        mark: '',
        content:
          '৭৫. আর্থিক মধ্যস্থতাকারীদের অতিরিক্ত কমিশন এবং সীমাবদ্ধতার জন্য বেটিং কোম্পানি দায়ী নয়। ক্লায়েন্ট সংশ্লিষ্ট আর্থিক প্রতিষ্ঠানগুলিতে অতিরিক্ত শর্তাবলী এবং হার খুঁজে পেতে পারেন।',
      },
      {
        mark: '',
        content:
          '৭৬. যদি জালিয়াতির সন্দেহ থাকে অথবা ব্যক্তিগত কার্ডের বিবরণ গেমিং অ্যাকাউন্টধারীর তথ্যের সাথে মেলে না, তাহলে বেটিং কোম্পানি ক্লায়েন্টের নির্বাচিত পেমেন্ট সিস্টেমের মাধ্যমে করা জমা বাতিল করার এবং কার্ডে ফেরত দেওয়ার অধিকার সংরক্ষণ করে। স্থাপন করা বাজি ১ অডসে নিষ্পত্তি করা হয়।',
      },
    ],
  },
  {
    title: 'জয়ের অর্থ প্রদান এবং উত্তোলনের নিয়ম',
    list: [
      {
        mark: '',
        content:
          '৭৭. নিষ্পত্তিকৃত বাজি থেকে জয়ের অর্থ অফিসিয়াল ওয়েবসাইটে ইভেন্টের ফলাফল ঘোষণার পরপরই জমা হয়।',
      },
      {
        mark: '',
        content:
          '৭৮. আপনার অ্যাকাউন্ট থেকে যেকোনো পরিমাণ অর্থ উত্তোলনের জন্য আপনি ২৪/৭ যেকোনো সময় অনুরোধ পাঠাতে পারেন, যা আপনার অ্যাকাউন্ট ব্যালেন্সের বেশি নয়। নিবন্ধনের সময় আপনি যে মুদ্রাটি উল্লেখ করেছিলেন সেই একই মুদ্রায় অর্থ উত্তোলন করা হবে। ৩ কার্যদিবসের মধ্যে অর্থ উত্তোলনের জন্য উপলব্ধ যেকোনো প্রদর্শিত পদ্ধতি ব্যবহার করে অর্থ উত্তোলন করা যেতে পারে। ১০০.০০ মার্কিন ডলারের বেশি অর্থ প্রদানের জন্য, বেটিং কোম্পানির অনুরোধকৃত আইডি ডকুমেন্টটি উপস্থাপন করা প্রয়োজন। বেটিং কোম্পানির নিজস্ব বিবেচনার ভিত্তিতে, মূল পাসপোর্ট সহ এবং শুধুমাত্র গেমিং অ্যাকাউন্ট হোল্ডারদের জন্য অনুরোধকৃত আইডি ডকুমেন্টটি উপস্থাপন করার পরেই তহবিল প্রদান করা হয়।',
      },
      {
        mark: '',
        content:
          '৭৯. গেমিং অ্যাকাউন্ট থেকে টাকা তোলা কেবলমাত্র তখনই সম্ভব যখন নিশ্চিত হওয়া যাবে যে গেমিং অ্যাকাউন্টধারী পেমেন্ট সিস্টেম অ্যাকাউন্টের মালিক। সম্পর্কের মাত্রা নির্বিশেষে অন্য ব্যক্তির অনুকূলে টাকা স্থানান্তর করা কঠোরভাবে নিষিদ্ধ।',
      },
      {
        mark: '',
        content:
          '৮০. তহবিল স্থানান্তরের সমস্ত খরচ প্রাপক বহন করবেন এবং স্থানান্তরিত পরিমাণ থেকে কেটে নেবেন। সমস্ত নিষ্পত্তি প্রযোজ্য নিয়ম অনুসারে করা হবে। আর্থিক তহবিল স্থানান্তরের জন্য সমস্ত বেটিং কোম্পানির চার্জের হার এবং কমিশনের হার ক্লায়েন্টের বসবাসের দেশ বা পরিষেবা গ্রহণের মুহূর্তে ক্লায়েন্ট কোথায় অবস্থিত তার উপর নির্ভর করে।',
      },
      {
        mark: '',
        content:
          '৮১. নির্বাচিত পেমেন্ট সিস্টেমের মাধ্যমে গেমিং অ্যাকাউন্ট থেকে ১০০.০০ মার্কিন ডলারের বেশি অর্থ উত্তোলনের প্রক্রিয়া সম্পাদন করতে, ক্লায়েন্টকে একটি যাচাইকরণ প্রক্রিয়া পাস করতে হবে। এটি করার জন্য, আপনার পাসপোর্ট এবং/অথবা অন্য কোনও পরিচয়পত্রের একটি রঙিন ছবি, যা বেটিং কোম্পানি অনুরোধ করতে পারে, এবং অ্যাকাউন্ট পুনরায় পূরণের জন্য ব্যবহৃত ক্রেডিট/ডেবিট কার্ডের সামনে এবং পিছনের একটি ছবি প্রদান করা যথেষ্ট। অনুগ্রহ করে মনে রাখবেন যে সমস্ত তথ্য স্পষ্টভাবে দৃশ্যমান হতে হবে এবং ক্লায়েন্টকে কার্ডের সামনের দিকের মাঝখানের ৮টি সংখ্যা এবং পিছনের দিকের ৩টি সংখ্যা সিকিউরিটি কোড বন্ধ করতে বাধ্য করা হবে। যদি কোনও কারণে ক্লায়েন্ট যাচাইকরণ থেকে অস্বীকৃতি জানায়, তাহলে বেটিং কোম্পানি কী সংশোধন করতে হবে সে সম্পর্কে মন্তব্য প্রদান করবে।',
      },
      {
        mark: '',
        content:
          '৮২. প্রত্যাহারের অর্ডার নিবন্ধনের সময় খাঁটি তথ্য প্রদানের জন্য ক্লায়েন্ট দায়ী।',
      },
      {
        mark: '',
        content:
          '৮৩. গেমিং অ্যাকাউন্ট থেকে উত্তোলনের জন্য বর্তমান শর্তাবলী এবং ফি পরিবর্তন করা যেতে পারে এবং সর্বদা "উৎপাদন" পৃষ্ঠায় প্রদর্শিত হয়। যদি ক্লায়েন্ট গেমিং অ্যাকাউন্টে জমা দেওয়ার জন্য "খালি" এবং অনুপযুক্ত লেনদেন করে, তাহলে বেটিং কোম্পানি ক্লায়েন্টের ভবিষ্যতের আর্থিক লেনদেনের জন্য পৃথক কমিশন নির্ধারণ করার অধিকার সংরক্ষণ করে, তবে কোন পরিমাণ বেশি তার উপর নির্ভর করে প্রতি লেনদেনে 2% বা 5 EUR (গেমিং অ্যাকাউন্ট মুদ্রার সমতুল্য) এর বেশি নয়।',
      },
      {
        mark: '',
        content:
          '৮৪. গেমিং অ্যাকাউন্ট থেকে VISA বা MasterCard-এ তহবিল উত্তোলনের জন্য, ক্লায়েন্টকে গেমিং অ্যাকাউন্টের মুদ্রায় একটি ব্যাংক অ্যাকাউন্ট থাকতে হবে না। আন্তর্জাতিক পেমেন্ট সিস্টেমগুলি স্বাধীনভাবে এবং স্বয়ংক্রিয়ভাবে যেকোনো অর্থ প্রদানকে বর্তমান আন্তঃব্যাংক বিনিময় হারের সাথে অন্য যেকোনো মুদ্রা থেকে গেমিং অ্যাকাউন্টের মুদ্রায় রূপান্তর করে।',
      },
      {
        mark: '',
        content:
          '৮৫. সর্বোচ্চ ৩ কার্যদিবসের মধ্যে গ্রাহকের ব্যাংক অ্যাকাউন্টে তহবিল জমা হয়ে যাবে।',
      },
      {
        mark: '',
        content:
          '৮৬. বেটিং কোম্পানির একটি কঠোর জালিয়াতি-বিরোধী নীতি রয়েছে। যদি বেটিং কোম্পানির বিশ্বাস করার যুক্তিসঙ্গত কারণ থাকে যে ক্লায়েন্ট কোনও ধরণের প্রতারণামূলক কার্যকলাপে অংশগ্রহণ করেছে বা এর সাথে যুক্ত হয়েছে (বেটিং কোম্পানি এবং তার গেমিং অংশীদার এবং অন্যান্য সরবরাহকারীদের দ্বারা ব্যবহৃত জালিয়াতি-বিরোধী, প্রতারণা-বিরোধী এবং যোগসাজশ সনাক্তকরণ পদ্ধতির ভিত্তিতে যা সাধারণত জুয়া খেলায় ব্যবহৃত হয়) যার মধ্যে রয়েছে, তবে সীমাবদ্ধ নয়:',
        list: [
          '১. অন্য ক্লায়েন্টের সাথে যেকোনো ধরণের যোগসাজশে অংশগ্রহণ করা;',
          '২. অন্যায্য জয়লাভের লক্ষ্যে কৌশল বিকাশ;',
          '৩. বেটিং কোম্পানি বা তার পেমেন্ট প্রদানকারীদের বিরুদ্ধে প্রতারণামূলক ব্যবস্থা;',
          '৪. চার্জব্যাক লেনদেন;',
          '৫. তৃতীয় পক্ষের সফ্টওয়্যার বা বিশ্লেষণ সিস্টেমের ব্যবহার;',
          '৬. দুই বা ততোধিক অ্যাকাউন্ট তৈরি করা (মাল্টি-অ্যাকাউন্টিং);',
          '৭. সালিসি বাজি;',
          '৮. বোনাস প্রোগ্রামের অপব্যবহার;',
          '৯. অন্যায্য বাহ্যিক কারণ বা প্রভাব ব্যবহার করা (সাধারণত প্রতারণা নামে পরিচিত);',
          '১০. তার বসবাসের দেশে দেউলিয়া হয়ে যাওয়া;',
          '১১. ক্লায়েন্টের গেমিং অ্যাকাউন্ট বেটিং এবং বেটিং কোম্পানি কর্তৃক প্রদত্ত অন্যান্য পণ্যের জন্য ব্যবহার করা হয় না;',
          '১২. গেমিং অ্যাকাউন্টটি অর্থ পাচার বা অন্যান্য প্রতারণামূলক কার্যকলাপের সাথে সম্পর্কিত কোনও কার্যকলাপে জড়িত বলে সন্দেহ করা হচ্ছে;',
          '১৩. গেমিং অ্যাকাউন্টটি অনিয়মিত (অস্বাভাবিক) লেনদেন কার্যকলাপ করছে বলে সন্দেহ করা হচ্ছে; অথবা',
          '১৪. কৃত্রিম টার্নওভার তৈরির উদ্দেশ্যে কৌশল তৈরি করা (ক্যাসিনোতে বিপরীত বাজি ধরা ইত্যাদি)।',
        ],
      },
      {
        mark: '',
        content: '৮৭. বাজি কোম্পানির অধিকার আছে:',
        list: [
          '১. ক্লায়েন্টের কার্যকলাপের তদন্তের উদ্দেশ্যে ক্লায়েন্ট অ্যাকাউন্ট অনির্দিষ্টকালের জন্য স্থগিত করা এবং তারপরে,',
          ' ২. যদি বেটিং কোম্পানির জালিয়াতি কার্যকলাপের সন্দেহ উত্থাপিত না হয় বা দূর না করা হয়, তাহলে বেটিং কোম্পানির অধিকার থাকবে যে তারা কেস-বাই-কেস ভিত্তিতে (তার নিজস্ব বিবেচনার ভিত্তিতে) নির্ধারিত যুক্তিসঙ্গত সময়ের মধ্যে এই ধরনের ক্লায়েন্টের অ্যাকাউন্ট বন্ধ করে দিতে পারে।',
          '৩. সমস্ত প্রতারণামূলক বা সন্দেহজনক প্রতারণামূলক কার্যকলাপ বা অস্বাভাবিক লেনদেন, তা সে বস্তুনিষ্ঠ সূচকের অধীনে (২,৫০০ মার্কিন ডলার বা সমতুল্য বা তার বেশি লেনদেন), অথবা ব্যক্তিগত সূচকগুলি GOAML কুরাকাও পোর্টালের মাধ্যমে FIU কুরাকাওকে রিপোর্ট করা হবে।',
        ],
      },
      {
        mark: '',
        content:
          '৮৮. বেটিং কোম্পানি সমাপ্ত চুক্তি বাতিল করার অধিকার সংরক্ষণ করে (যদি ইভেন্ট শুরুর আগে বা পরে রাখা বাজি (লাইভ বা ভার্চুয়াল) অথবা এই ওয়েবসাইটের যেকোনো ভার্চুয়াল গেম, পণ্য বা ক্যাসিনো পণ্য সহ (কিন্তু সীমাবদ্ধ নয়), এই ধরনের চুক্তির অধীনে বাধ্যবাধকতা পূরণ করতে অস্বীকার করে (যদি কোনও জয়ের অর্থ প্রদানে অস্বীকৃতি (কিন্তু সীমাবদ্ধ নয়)) অথবা কোনও বাজি ফেরত দেওয়ার অধিকার সংরক্ষণ করে, যদি:',
        list: [
          '১. বেটিং কোম্পানি আবিষ্কার করেছে যে বাজি চুক্তি, বাজি বা জয় নিম্নলিখিত এক বা একাধিক ইভেন্টের ফলাফলকে বোঝায়:  যেখানে ক্লায়েন্ট একজন পেশাদার বা কলেজিয়েট ক্রীড়াবিদ, দলের কর্মচারী এবং মালিক, কোচ, ম্যানেজার, হ্যান্ডলার, অ্যাথলেটিক প্রশিক্ষক, লীগ কর্মকর্তা এবং কর্মচারী, রেফারি, আম্পায়ার, স্পোর্টস এজেন্ট এবং খেলোয়াড় বা রেফারি ইউনিয়নের কর্মচারী, সেইসাথে একই পরিবারের সদস্য হিসেবে অংশগ্রহণ করে, অথবা  যেখানে একটি স্পোর্টস ক্লাব অংশগ্রহণ করে, যেখানে ক্লায়েন্ট একজন মালিক, কোচ, একজন কর্মী বা খেলোয়াড়, অথবা যার জন্য ক্লায়েন্ট এই উপ-অনুচ্ছেদের "i" বা "ii" উপ-অনুচ্ছেদে উল্লেখিত ব্যক্তির পক্ষে চুক্তিতে স্বাক্ষর করেছেন। বেটিং কোম্পানি কখন থেকে সচেতন হয়েছে যে ক্লায়েন্ট মনোনীত ব্যক্তিদের মধ্যে একজন এবং পূর্ববর্তীভাবে প্রয়োগ করা যেতে পারে তা নির্বিশেষে এই নিয়ম প্রযোজ্য। যদি ইভেন্ট চলাকালীন অন্যায্যতার ঘটনা বা কোনও ইভেন্টের ফলাফলের উপর অন্যায্যতার ঘটনার প্রভাব সম্পর্কে বেটিং কোম্পানির যুক্তিসঙ্গত সন্দেহ থাকে, তাহলে ক্লায়েন্ট এবং বেটিং কোম্পানি একটি বাজি চুক্তিতে পৌঁছেছে, বেটিং কোম্পানি এই ধরণের ঘটনার ফলাফল সন্দেহজনক কিনা তা বিবেচনা করার অধিকার সংরক্ষণ করে, যার ফলে বেটিং কোম্পানি বা অন্যান্য ব্যক্তিদের দ্বারা অন্যায্যতার সন্দেহের সাথে সম্পর্কিত সমস্ত তদন্ত শেষ হওয়ার আগে এই ধরণের বাজির ক্ষেত্রে জয়ের নিষ্পত্তি এবং ক্লায়েন্টকে জয়ের অর্থ প্রদান স্থগিত করা হয়। যদি এই তদন্তটি কোনও সত্যতা প্রতিষ্ঠা করে বা ইভেন্ট চলাকালীন অসততা, ক্রীড়া সংগ্রাম, বা ইভেন্টের ফলাফলের উপর অন্যায্যতার প্রভাবের সন্দেহকে শক্তিশালী করে, তাহলে বেটিং কোম্পানির এই ধরণের ঘটনার ক্ষেত্রে ক্লায়েন্টের বাজি ফেরত প্রত্যাখ্যান করার এবং/অথবা বাতিল করার অধিকার রয়েছে, এবং আইন দ্বারা প্রতিষ্ঠিত অন্যায্যতার ঘটনায় ক্লায়েন্টের জড়িত থাকার তদন্ত করার জন্য আইন প্রয়োগকারী কর্তৃপক্ষের সাথে যোগাযোগ করার এবং তাকে দায়বদ্ধতার আওতায় আনার অধিকার রয়েছে। ১. যদি বেটিং কোম্পানি কর্তৃক বাজি বা এর কিছু অংশ সন্দেহজনক বলে স্বীকৃতি পাওয়ার ১০৯৫ দিনের মধ্যে এই তদন্তগুলি সম্পন্ন না হয়, তাহলে বেটিং কোম্পানি ক্লায়েন্টের লিখিত অনুরোধে একটি সন্দেহজনক বাজিকে অবৈধ (বাতিল) ঘোষণা করবে এবং ক্লায়েন্টকে হার ফেরত দেবে।',
          '2. এই বিধিমালার অনুচ্ছেদ 86 (b) এর উদ্দেশ্যে: অন্যায় ঘটনার মধ্যে এমন পরিস্থিতি (কিন্তু সীমাবদ্ধ নয়) অন্তর্ভুক্ত যেখানে ইভেন্টের ফলাফল সম্পূর্ণ বা আংশিকভাবে পূর্বনির্ধারিত ছিল তার সদস্য এবং/অথবা তৃতীয় পক্ষের মধ্যে যোগসাজশের ফলে, অথবা যখন একটি চুক্তিভিত্তিক ম্যাচ সংঘটিত হয়েছিল, যেমনটি প্রাসঙ্গিক ক্রীড়া ইভেন্ট পরিচালনার নিয়মে সংজ্ঞায়িত করা হয়েছে, অথবা যখন একটি সরকারী ক্রীড়া ইভেন্ট বা অন্যান্য ইভেন্টের ফলাফলের উপর অবৈধ প্রভাব ছিল; অন্যায় ঘটনার উপস্থিতিতে বেটিং কোম্পানির সন্দেহ ন্যায্য, বিশেষ করে যখন এই ধরনের সন্দেহ একটি জাতীয়, আন্তর্জাতিক বা বিদেশী সংস্থা থেকে আসে যারা ম্যাচ ফিক্সিং বা অন্যান্য খেলার সনাক্তকরণ, প্রতিরোধ বা বিরোধিতায় বিশেষজ্ঞ, যার ফলাফল পূর্ব-নির্ধারিত (উদাহরণস্বরূপ, টেনিস ইন্টিগ্রিটি ইউনিট (TIU), আর্লি ওয়ার্নিং সিস্টেম GmbH (EWS), ফেডারবেট AISBL)।',
          '৩. এটি নির্ধারণ করা হয়েছে যে: একজন ক্লায়েন্টের একাধিক গেম অ্যাকাউন্ট রয়েছে (একাধিক নিবন্ধন, একাধিক অ্যাকাউন্ট), যার মধ্যে একটি নতুন নামেও অন্তর্ভুক্ত; একজন ক্লায়েন্ট তার পরিবারের সদস্যদের সহ নতুন গেমিং অ্যাকাউন্ট নিবন্ধন করতে অন্য ব্যক্তির ডেটা ব্যবহার করে; বেটিং কোম্পানি কর্তৃক প্রতিষ্ঠিত বিধিনিষেধ এড়াতে যোগসাজশে কাজ করা ক্লায়েন্টদের একটি দল দ্বারা বাজি ধরা হয়; ক্লায়েন্ট এমন কোনও সফ্টওয়্যার ব্যবহার করছেন বলে সন্দেহ করা হয় যা বাজি স্থাপনের প্রক্রিয়াটিকে স্বয়ংক্রিয় করে তোলে; সালিসি পরিস্থিতিতে খেলার জন্য একটি গেম অ্যাকাউন্ট ব্যবহার করে; বেটিং কোম্পানি কর্তৃক প্রদত্ত বাজি এবং অন্যান্য পণ্যের জন্য গেমিং অ্যাকাউন্ট ব্যবহার করা হয় না; আনুগত্য প্রোগ্রামের অপব্যবহার করা হয়; মানি লন্ডারিং বা অন্যান্য প্রতারণামূলক কার্যকলাপের সাথে সম্পর্কিত কোনও কার্যকলাপে গেমিং অ্যাকাউন্ট সন্দেহ করা হয়; গেমিং অ্যাকাউন্টটি অনিয়মিত (অস্বাভাবিক) লেনদেন কার্যকলাপ করার জন্য সন্দেহ করা হয়; কৃত্রিম টার্নওভার তৈরি করার উদ্দেশ্যে কৌশল তৈরি করা (ক্যাসিনোতে বিপরীত বাজি তৈরি করা ইত্যাদি)।',
          '৪. বেটিং কোম্পানি ক্লায়েন্টের উপর আস্থা হারিয়ে ফেলেছে। যদি ক্লায়েন্ট যাচাই প্রক্রিয়ার সময় কোনও বাজির (অথবা বাজির) ইতিহাস ব্যাখ্যা করতে না পারে যে বিডটি কোন নীতিমালার ভিত্তিতে তৈরি করা হয়েছিল, বাজি ধরার সময় ক্লায়েন্ট কী দ্বারা পরিচালিত হয়েছিল, কেন তিনি এই ইভেন্টে আগ্রহী ছিলেন বা বেট সেট সম্পর্কিত অন্য কোনও প্রশ্ন। বেটিং কোম্পানি ক্লায়েন্টকে জিজ্ঞাসা করা প্রয়োজন বলে মনে করবে। যদি ক্লায়েন্টের দেওয়া উত্তরগুলি বেট সেটের সততা সম্পর্কে সন্দেহ তৈরি করে, তাহলে এর ফলে এই ক্লায়েন্টের সাথে বেটিং কোম্পানির আস্থা নষ্ট হবে। এই ক্ষেত্রে, বেটিং কোম্পানির ক্লায়েন্ট অ্যাকাউন্টটি অনির্দিষ্টকালের জন্য স্থগিত করার বা অ্যাকাউন্টটি স্থায়ীভাবে বন্ধ করার অধিকার রয়েছে, যা কেস-বাই-কেস ভিত্তিতে বেটিং কোম্পানি দ্বারা নির্ধারিত হতে পারে। পূর্বোক্ত প্রমাণগুলি বেটিং কোম্পানিতে বেটিং এর আকার, আয়তন এবং কাঠামোর উপর ভিত্তি করে হতে পারে। তালিকাভুক্ত যেকোনো বিষয়ে (যদি থাকে) বেটিং কোম্পানির নেতৃত্ব কর্তৃক গৃহীত সিদ্ধান্ত চূড়ান্ত। যদি কোনও কারণে ক্লায়েন্টের ঋণাত্মক ব্যালেন্স থাকে, তাহলে বেটিং কোম্পানি এই ক্লায়েন্টকে কোনও অর্থ প্রদান গ্রহণ করার আগে এটি বিবেচনা করার অধিকার সংরক্ষণ করে। এই ক্ষেত্রে, বেটিং কোম্পানির ক্লায়েন্ট অ্যাকাউন্টটি অনির্দিষ্টকালের জন্য স্থগিত করার বা স্থায়ীভাবে অ্যাকাউন্টটি বন্ধ করার অধিকার রয়েছে, যা কেস-বাই-কেস ভিত্তিতে বেটিং কোম্পানি দ্বারা নির্ধারিত হতে পারে।',
          '৫. প্রযুক্তিগত ত্রুটির কারণে ক্লায়েন্ট বা তৃতীয় পক্ষের দ্বারা সৃষ্ট ক্ষতি এবং ক্ষতির জন্য বেটিং কোম্পানি দায়ী নয়, যার মধ্যে ভাইরাস আক্রমণ বা এই ওয়েবসাইটে নির্দেশিত অন্যান্য দূষিত পদক্ষেপ, সফ্টওয়্যার সরবরাহকারীর (তৃতীয় পক্ষ) পক্ষের ব্যর্থতা, সার্ভার এবং ইলেকট্রনিক যোগাযোগ চ্যানেলের সমস্যা এবং অন্যান্য অন্তর্ভুক্ত। যদি ক্লায়েন্টের অ্যাকাউন্টে ভুলবশত এমন জয় জমা হয় যা ক্লায়েন্টের নয়, সফ্টওয়্যার সরবরাহকারী (তৃতীয় পক্ষ) সহ, বেটিং কোম্পানি ক্লায়েন্টকে এই ধরনের জয় দিতে বাধ্য নয়। বেটিং কোম্পানি প্রযুক্তিগত ত্রুটি বা দুর্বলতার ইচ্ছাকৃত বা অনিচ্ছাকৃত ব্যবহারের ফলে প্রাপ্ত যেকোনো অর্থ স্থগিত, প্রত্যাহার বা বাতিল করার অধিকার সংরক্ষণ করে। ক্লায়েন্ট এই ধরনের সমস্ত প্রত্যাহার করা ভুল জয় এবং অর্থ প্রদান ফেরত দিতে বাধ্য, এবং বেটিং কোম্পানির পরবর্তী অ্যাকাউন্ট জমা থেকেও সেগুলি সংগ্রহ করার অধিকার রয়েছে। তহবিলের ভুল জমা এবং/অথবা কোনও প্রযুক্তিগত ত্রুটি বা দুর্বলতা সনাক্তকরণের ক্ষেত্রে, ক্লায়েন্ট সহায়তা পরিষেবাকে অবহিত করতে বাধ্য। কোনও নির্দিষ্ট ক্ষেত্রে স্পষ্ট বা সুপ্ত প্রযুক্তিগত ত্রুটি সংঘটিত হয়েছে কিনা তা নির্ধারণের অধিকার কেবল বেটিং কোম্পানির।',
          '৬. বেটিং কোম্পানি আর্থিক ও প্রযুক্তিগত অংশীদার এবং এজেন্টদের কার্যক্রমের মানের জন্য দায়ী নয়।',
          '৭. বেটিং সেটেলমেন্ট সিস্টেমে কারিগরি সমস্যার ক্ষেত্রে, ক্লায়েন্টকে অর্থপ্রদান নিয়ম দ্বারা নির্ধারিত পদ্ধতিতে করা হয়।',
        ],
      },
      {
        mark: '',
        content:
          '৮৯. যদি ক্লায়েন্টের অ্যাকাউন্ট জালিয়াতি বা অন্যান্য অবৈধ কর্মকাণ্ডের কারণে ব্লক করা হয়, তাহলে তার গেমিং অ্যাকাউন্টের বাকি অর্থ বেটিং কোম্পানি ক্লায়েন্টের এই ধরনের কর্মকাণ্ডের দ্বারা প্রভাবিত ব্যক্তিদের কাছে অথবা দাতব্য অবদানের জন্য স্থানান্তর করে।',
      },
      {
        mark: '',
        content:
          '৯০. টাকা তোলার জন্য, ক্লায়েন্টকে জমাকৃত পরিমাণের কমপক্ষে সত্তর (৭০) শতাংশ বাজি ধরতে হবে।',
      },
      {
        mark: '',
        content:
          '৯১. বেটিং কোম্পানি কমিশন নির্ধারণ, লেনদেনের সংখ্যা এবং সীমা সহ যেকোনো উপায়ে ক্লায়েন্টের অ্যাকাউন্ট থেকে তহবিল উত্তোলনের অধিকার সংরক্ষণ করে।',
      },
      {
        mark: '',
        content:
          '৯২. যাচাইকরণের সময় বেটিং কোম্পানি গেমিং অ্যাকাউন্টধারীর পরিচয় যাচাই করার এবং লেনদেন এবং/অথবা গেমিং অ্যাকাউন্টের জন্য অর্থ প্রদান স্থগিত করার অধিকার সংরক্ষণ করে।',
      },
      {
        mark: '',
        content:
          'গেমিং অ্যাকাউন্টটি প্রকৃত তথ্য দিয়ে নিবন্ধিত হয়েছে এবং ক্লায়েন্টের বয়স ১৮ বছর হয়েছে কিনা তা নিশ্চিত করার জন্য প্রাথমিক যাচাইকরণ করা হয়। তার পরিচয় যাচাই করার জন্য, ক্লায়েন্ট গেমিং অ্যাকাউন্ট সেটিংস থেকে তার নিজ দেশের সিভিল পাসপোর্ট বা জাতীয় পরিচয়পত্রের একটি ছবি ডাউনলোড করতে পারেন। ডকুমেন্টে প্রথম নাম, পদবি, ছবি, জন্ম তারিখ, ডকুমেন্টের নম্বর স্পষ্টভাবে দৃশ্যমান হতে হবে। শুধুমাত্র ডকুমেন্টের রঙিন ছবি গ্রহণ করা যেতে পারে (কালো-সাদা স্ক্যান এবং ডকুমেন্টের কপি অনুমোদিত নয়)। ডকুমেন্ট পৃষ্ঠাগুলি সম্পূর্ণরূপে দৃশ্যমান হতে হবে। গ্রহণযোগ্য ডকুমেন্ট ভাষা - ইংরেজি, হিন্দি। গ্রহণযোগ্য ফাইল ফর্ম্যাট: jpg, jpeg, pdf, gif, ১০ MB এর বেশি নয়।',
      },
      {
        mark: '',
        content:
          '৯৩. যদি ক্লায়েন্ট ৩০ দিনের মধ্যে যাচাইয়ের জন্য প্রয়োজনীয় নথি সরবরাহ করতে ব্যর্থ হয়, তাহলে বেটিং কোম্পানি তার বিবেচনার ভিত্তিতে ক্লায়েন্টের ব্যালেন্স কেটে নেওয়ার এবং একটি রাইট-অফ করার অধিকার সংরক্ষণ করে।',
      },
      {
        mark: '',
        content:
          '৯৪. প্রয়োজনে, বেটিং কোম্পানি সর্বদা অতিরিক্ত পরিচয় প্রমাণের প্রয়োজন করতে পারে, তা ক্লায়েন্ট প্রাথমিক অ্যাকাউন্ট যাচাইয়ে উত্তীর্ণ হয়েছেন কিনা তা বিবেচনা না করেই। অতিরিক্ত নথির তালিকার মধ্যে রয়েছে (কিন্তু সীমাবদ্ধ নয়): পাসপোর্ট, ড্রাইভিং লাইসেন্স, জন্ম সনদ, আন্তর্জাতিক পাসপোর্ট, ইউটিলিটি বিল, অ্যাকাউন্ট/কার্ডের জন্য ব্যাংক স্টেটমেন্ট ইত্যাদি সহ ক্লায়েন্টের একটি ডিজিটাল ছবি। ক্লায়েন্ট spinbajifeedback@gmail.com ঠিকানায় একটি ইমেল পাঠিয়ে এই নথিগুলি সরবরাহ করতে পারেন। প্রতিটি গেম অ্যাকাউন্টের জন্য গেম অ্যাকাউন্ট যাচাইয়ের সময় পৃথকভাবে সেট করা হয়। উন্নত যাচাইকরণের ক্ষেত্রে, ক্লায়েন্টকে ১ ক্যালেন্ডার মাসের মধ্যে (এই ধরনের যাচাইকরণ শুরু করার পরে) সমস্ত অনুরোধকৃত নথি সরবরাহ করতে হবে। অপারেটর তার নিজস্ব বিবেচনার ভিত্তিতে ক্লায়েন্টের অ্যাকাউন্ট থেকে যেকোনো জয় বাতিল করার এবং ক্লায়েন্ট অনুরোধকৃত নথি সরবরাহ করতে ব্যর্থ হলে অ্যাকাউন্টটি সীমাবদ্ধ বা এমনকি বন্ধ করার অধিকার সংরক্ষণ করে।',
      },
      {
        mark: '',
        content:
          '৯৫. বেটিং কোম্পানির যুক্তিসঙ্গত সন্তুষ্টির জন্য প্রদত্ত পরিচয় যাচাইকরণ পদ্ধতি থেকে ক্লায়েন্ট কর্তৃক অস্বীকৃতি (এড়িয়ে চলা) হলে, অন্যের, জাল (বিভিন্ন প্রোগ্রাম এবং গ্রাফিক সম্পাদকের সাহায্যে সম্পাদিত) নথি এবং/অথবা ক্লায়েন্ট-বেটিং কোম্পানির সাধারণ অসঙ্গতি সরবরাহের মাধ্যমে ক্লায়েন্ট কর্তৃক স্থাপন করা সমস্ত বাজি বাতিল করার এবং সমস্ত স্থানান্তরিত তহবিল গেমিং অ্যাকাউন্টে ফেরত দেওয়ার সিদ্ধান্ত নিতে পারে, যার সাথে উক্ত অ্যাকাউন্টটি স্থগিত করার বা অ্যাকাউন্টটি বন্ধ করার আরও স্পষ্ট অধিকার থাকবে (বেটিং কোম্পানির নিজস্ব বিবেচনার ভিত্তিতে নির্ধারণ করা হবে)।',
      },
      {
        mark: '',
        content:
          '৯৬. বেটিং কোম্পানি নিবন্ধনের সময় অর্জিত ক্লায়েন্ট, বাজি ধরা, ক্লায়েন্টের গেমিং ফলাফল এবং সরকারি সংস্থাগুলির অনুরোধে তার সাথে পেমেন্ট নিষ্পত্তি সম্পর্কিত তথ্য সরবরাহের জন্য দায়ী নয়। ক্লায়েন্ট বেটিং কোম্পানিকে তার আর্থিক স্বচ্ছলতা মূল্যায়ন বা তার জন্য বিপণন পণ্য এবং পরিষেবা নির্বাচনের উদ্দেশ্যে ব্যক্তিগত তথ্য সংগ্রহ, সংরক্ষণ এবং ব্যবহার করার অনুমতি দেয়।',
      },
    ],
  },
  {
    title: 'নিষ্ক্রিয় অ্যাকাউন্ট',
    list: [
      {
        mark: '',
        content:
          '৯৭. একটি নিষ্ক্রিয় ("স্লিপিং") অ্যাকাউন্ট হল বেটিং কোম্পানির একটি গেমিং অ্যাকাউন্ট, যেখানে এক বছরেরও বেশি সময় ধরে (১২ মাস) কোনও নিবন্ধিত হয়নি I) সফল আমানত, II) ইভেন্ট বা অনলাইন গেমের উপর বাজি, III) উত্তোলন।',
      },
      {
        mark: '',
        content:
          '৯৮. শিল্পের মান অনুসারে, যতক্ষণ আপনি বেটিং কোম্পানির পণ্যগুলি সক্রিয়ভাবে ব্যবহার করেন ততক্ষণ আপনার অ্যাকাউন্টের রক্ষণাবেক্ষণ বিনামূল্যে থাকে। যদি আপনার অ্যাকাউন্টে "ঘুমন্ত" হওয়ার লক্ষণ থাকে, তাহলে প্রশাসনিক খরচ মেটাতে একটি নিষ্ক্রিয় অ্যাকাউন্ট পরিষেবা প্রদানের জন্য প্রশাসনিক ফি একটি ইতিবাচক অ্যাকাউন্ট ব্যালেন্স থেকে কেটে নেওয়া হবে। যদি আপনার অ্যাকাউন্টে শূন্য ব্যালেন্স থাকে, তাহলে কোনও ফি নেওয়া হবে না।',
      },
      {
        mark: '',
        content:
          '৯৯. মালিককে তার অ্যাকাউন্টের নিষ্ক্রিয় অবস্থা এবং প্রোফাইলে প্রদত্ত যোগাযোগের তথ্য ব্যবহার করে অ্যাকাউন্টটি পরিষেবা দেওয়ার জন্য প্রথম চার্জ সম্পর্কে অবহিত করা হবে এবং নিশ্চিত করা হবে। একটি ইতিবাচক অ্যাকাউন্ট থেকে প্রশাসনিক ফি অ্যাকাউন্টের নিষ্ক্রিয় অবস্থা সম্পর্কে প্রথম বিজ্ঞপ্তির ৩০ দিন পর থেকে মাসিক চার্জ করা হবে, এবং যতক্ষণ না অ্যাকাউন্টে আর কোনও তহবিল অবশিষ্ট থাকে বা এটি আবার সক্রিয় না হয়। এবং একটি নিষ্ক্রিয় অ্যাকাউন্টে প্রথম চার্জের সাথে, সমস্ত বোনাস প্রচারণাও নিষ্ক্রিয় করা হয়, বোনাস এবং অন্যান্য যেকোনো পয়েন্ট বা প্রচারণা, লয়্যালটি প্রোগ্রাম বা অন্যান্য প্রোগ্রাম বা বেটিং কোম্পানির প্রচারণায় অর্থ জমা হওয়া যা এই গেম অ্যাকাউন্টে আগে সক্রিয় করা হয়েছিল তা বাতিল করা হয়। এই নিয়মের অন্যান্য পয়েন্টগুলি পূরণ হলে, অ্যাকাউন্ট মালিকের যেকোনো সময় উপলব্ধ পেমেন্ট পদ্ধতির মাধ্যমে একটি ইতিবাচক ব্যালেন্স উত্তোলনের অধিকার রয়েছে।',
      },
      {
        mark: '',
        content:
          '১০০. একটি নিষ্ক্রিয় অ্যাকাউন্টের মালিক বেটিং কোম্পানিতে তার অ্যাকাউন্ট "সক্রিয়" করতে পারেন I) একটি সফল আমানত, II) কোনও ইভেন্ট বা অনলাইন গেমে বাজি ধরা, III) যেকোনো সময় তহবিল উত্তোলন করে।',
      },
      {
        mark: '',
        content:
          '১০১. বেটিং কোম্পানিতে নিষ্ক্রিয় অ্যাকাউন্ট পরিষেবা প্রদানের জন্য ফি ইউরোতে নেওয়া হয় এবং এর পরিমাণ ৫ ইউরো (অথবা গেম অ্যাকাউন্টের মুদ্রার সমতুল্য)। বেটিং কোম্পানির অভ্যন্তরীণ বিনিময় হারে নির্দিষ্ট পরিমাণকে ইউরোতে রূপান্তর করে গেম অ্যাকাউন্টের মুদ্রার সমতুল্য নির্ধারণ করা হয়, যখন বেটিং কোম্পানিকে অ্যাকাউন্ট রক্ষণাবেক্ষণ ফি নিতে হবে। যদি অ্যাকাউন্টের ব্যালেন্স ৫ ইউরোর কম হয় (অথবা গেম অ্যাকাউন্টের মুদ্রার সমতুল্য), তাহলে অবশিষ্ট পরিমাণ অ্যাকাউন্ট থেকে তুলে নেওয়া হবে যতক্ষণ না ব্যালেন্স ০ ইউরো (অথবা গেম অ্যাকাউন্টের মুদ্রার সমতুল্য) হয়।',
      },
      {
        mark: '',
        content:
          '১০২. অ্যাকাউন্ট ব্যালেন্স শূন্যে নেমে আসার পর, বেটিং কোম্পানি একটি নিষ্ক্রিয় অ্যাকাউন্ট বন্ধ করার (এর রক্ষণাবেক্ষণ এবং অ্যাক্সেস বন্ধ করার) অধিকার সংরক্ষণ করে।',
      },
    ],
  },
  {
    title: 'বেটিং কোম্পানির গ্রাহক সহায়তা পরিষেবার সাথে যোগাযোগ',
    list: [
      {
        mark: '',
        content:
          '১০৩. বেটিং কোম্পানির গ্রাহক সহায়তা পরিষেবার সাথে যোগাযোগ করার সময় (এরপর থেকে গ্রাহক সহায়তা হিসাবে উল্লেখ করা হবে), ক্লায়েন্টকে অবশ্যই গ্রাহক সহায়তার অপারেটর এবং বেটিং কোম্পানির অন্যান্য কর্মচারীদের সাথে সম্মানের সাথে যোগাযোগ করতে হবে, বিশেষ করে, স্পষ্টভাবে এবং সারমর্মের সাথে তাদের প্রশ্নগুলি প্রকাশ করতে হবে, সহায়তা পরিষেবার অপারেটর বা বেটিং কোম্পানির অন্য কোনও কর্মচারীর অনুরোধগুলি কার্যকর করতে হবে। গ্রাহক সহায়তার অপারেটর কেবলমাত্র সমাপ্ত বাজি চুক্তি বা বাজি সম্পর্কে একটি চুক্তি সম্পাদন এবং সম্পাদনের সম্ভাবনার ক্ষেত্রে ক্লায়েন্টকে সহায়তা প্রদান করে এবং অন্যান্য বিষয়ে পরামর্শ প্রদান প্রত্যাখ্যান করার অধিকার রাখে।',
      },
      {
        mark: '',
        content:
          '১০৪. গ্রাহক সহায়তার অপারেটরের সাথে কথোপকথনের সময় ক্লায়েন্ট নিম্নলিখিত বিষয়গুলি স্বীকার করেন:',
        list: [
          '১. অশ্লীল বা অশ্লীল অভিব্যক্তি ব্যবহার করবেন না;',
          '২. অপারেটরকে অপমান করবেন না এবং তার মর্যাদা ক্ষুণ্ন করবেন না;',
          '৩. বেটিং কোম্পানির অপারেটর বা অন্যান্য কর্মচারীদের হুমকি দেবেন না;',
          '৪. বাজি চুক্তি বা বাজি চুক্তি সম্পাদন এবং সম্পাদনের সম্ভাবনার সাথে সম্পর্কিত নয় এমন বিষয়ে গ্রাহক সহায়তার অপারেটরের সাথে যোগাযোগ না করা;',
          '৫. গ্রাহক সহায়তার সাথে যোগাযোগ করার অধিকারের অপব্যবহার করবেন না এবং গ্রাহক সহায়তার স্বাভাবিক কার্যক্রমে হস্তক্ষেপ করবেন না (বারবার আবেদন, স্প্যাম, বন্যা ইত্যাদি)।',
        ],
      },
      {
        mark: '',
        content:
          '১০৫. গ্রাহক সহায়তার অপারেটরের সাথে যোগাযোগের সময় যদি ক্লায়েন্ট এই নিয়মের অনুচ্ছেদ ১০২ লঙ্ঘনের অনুমতি দেন, তাহলে অপারেটর:',
        list: [
          '১. ক্লায়েন্টকে সতর্ক করে যে তার আচরণ এই নিয়ম লঙ্ঘন;',
          '২. লঙ্ঘনের অবসান দাবি করে এবং ক্লায়েন্টকে এই নিয়মাবলীর ১০৪ অনুচ্ছেদে বর্ণিত পরিণতি সম্পর্কে সতর্ক করে, যদি ক্লায়েন্ট এই নিয়মাবলী লঙ্ঘন চালিয়ে যান।',
        ],
      },
      {
        mark: '',
        content:
          '১০৬. যদি অপারেটর ক্লায়েন্টকে সতর্ক করে দেয় কিন্তু ক্লায়েন্ট এই নিয়মের অনুচ্ছেদ ১০২ লঙ্ঘন অব্যাহত রাখে, তাহলে অপারেটর ১ দিন থেকে ৩ মাসের জন্য গ্রাহক সহায়তায় আবেদন করার ক্লায়েন্টের অধিকার সাময়িকভাবে স্থগিত করার সিদ্ধান্ত নেয়। অপারেটরের সমাধান চূড়ান্ত। বেটিং কোম্পানির গ্রাহক সহায়তায় যোগাযোগ করার জন্য এই ধরনের ক্লায়েন্টের অ্যাক্সেস স্বয়ংক্রিয়ভাবে ব্লক করার জন্য প্রযুক্তিগত উপায় ব্যবহার করার অধিকার রয়েছে। বেটিং কোম্পানি ক্লায়েন্টকে গ্রাহক সহায়তায় আবেদন করার তার অধিকার পুনর্নবীকরণের বিষয়ে অবহিত করে না।',
      },
    ],
  },
  {
    title: 'নগদ আউট',
    list: [
      {
        mark: '',
        content:
          '১০৭. "ক্যাশআউট" বিকল্পটি হল ফলাফল জানার আগেই আপনার বাজি নিষ্পত্তি করার ক্ষমতা।',
      },
      {
        mark: '',
        content:
          '১০৮. "ক্যাশআউট" এর পরিমাণ আপনার নির্বাচিত খেলার ইভেন্টের গতিপথ এবং প্রতিকূলতার পরিবর্তনের উপর নির্ভর করে। এটি আপনার মূল বাজির চেয়ে বেশি বা কম হতে পারে।',
      },
      {
        mark: '',
        content:
          '১০৯. "ক্যাশআউট" বিকল্পটি শুধুমাত্র আপনার অমীমাংসিত বাজির জন্য উপলব্ধ।',
      },
      {
        mark: '',
        content:
          '১১০. "ক্যাশআউট" বিকল্পটি প্রাক-ম্যাচ এবং লাইভ বেটিং উভয়ের জন্যই সক্রিয় থাকবে।',
      },
      {
        mark: '',
        content:
          '১১১. যদি আপনার একাধিক বাজি থাকে (একক বাজি এবং পার্লে অথবা একাধিক একক বাজি এবং পার্লে), তাহলে এই প্রতিটি বাজির জন্য আলাদাভাবে "ক্যাশআউট" বিকল্পটি উপলব্ধ থাকবে।',
      },
      {
        mark: '',
        content:
          '১১২. "ক্যাশআউট" বিকল্পটি শুধুমাত্র পুরো পার্লে-এর জন্য উপলব্ধ, তবে এর পৃথক ইভেন্টের জন্য নয়। যদি পার্লে-তে কোনও ইভেন্ট আপনার বাজি অনুসারে শেষ হয়ে যায়, তাহলে "ক্যাশআউট" বিকল্পটি আপনার ইতিমধ্যে জিতে নেওয়া লাভ রেকর্ড করার জন্য উপলব্ধ থাকবে।',
      },
      {
        mark: '',
        content:
          '১১৩. "ক্যাশআউট" বিকল্পটি এই শর্তে প্রদান করা হয় যে, আপনি যে বাজারে বাজি রেখেছেন, সেগুলি এখনও খোলা থাকবে।',
      },
      {
        mark: '',
        content:
          '১১৪. আপনি "অ্যাকাউন্ট ইতিহাস" ট্যাবে আপনার অমীমাংসিত বাজিতে "ক্যাশআউট" বিকল্পটি প্রয়োগ করতে পারেন।',
      },
      {
        mark: '',
        content:
          '১১৫. আপনার প্রতিটি বাজির পাশে নিষ্পত্তির পরিমাণ প্রদর্শিত হবে যার জন্য "ক্যাশআউট" উপলব্ধ।',
      },
      {
        mark: '',
        content:
          '১১৬. বেটিং কোম্পানি গ্যারান্টি দেয় না যে "ক্যাশআউট" বিকল্পটি যেকোনো সময় উপলব্ধ থাকবে।',
      },
      {
        mark: '',
        content:
          '১১৭. যদি আপনার "ক্যাশআউট" অনুরোধটি একটি পৃথক বাজির জন্য সফল হয়, তাহলে আপনার বাজি তাৎক্ষণিকভাবে নিষ্পত্তি করা হবে এবং উপযুক্ত পরিমাণ তহবিল আপনার গেমিং অ্যাকাউন্টে জমা হবে। এই ক্ষেত্রে, নির্বাচিত ইভেন্টের ফলাফল এই বাজির নিষ্পত্তির জন্য গুরুত্বপূর্ণ হবে না।',
      },
      {
        mark: '',
        content:
          '১১৮. বেটিং কোম্পানি যেকোনো ধরণের খেলাধুলা, প্রতিযোগিতা বা বাজারের জন্য যেকোনো "ক্যাশআউট" অনুরোধ গ্রহণ বা প্রত্যাখ্যান করার অধিকার সংরক্ষণ করে।',
      },
      {
        mark: '',
        content:
          'যদি ইংরেজি ভাষার সাইট এবং অন্য কোনও ভাষার সাইটের মধ্যে নিয়মকানুনগুলির মধ্যে পার্থক্য থাকে, তাহলে ইংরেজি ভাষার নিয়মগুলি প্রযোজ্য হবে।',
      },
    ],
  },
];
export const privacyPolicy = [
  {
    title: 'এই গোপনীয়তা নীতির উদ্দেশ্য',
    content:
      ' বর্তমান ওয়েবসাইটের তথ্য সংগ্রহ এবং প্রচারের পদ্ধতিগুলি নীচে বর্ণনা করা হয়েছে:',
  },
  {
    title: 'খেলোয়াড়দের তথ্যের ব্যবহার',
    list: [
      '১. খেলোয়াড়ের ব্যক্তিগত তথ্য (অর্থাৎ আপনার সম্পর্কে এমন কোনও তথ্য যা থেকে আপনাকে ব্যক্তিগতভাবে শনাক্ত করা যেতে পারে, যেমন আপনার নাম, ঠিকানা, টেলিফোন নম্বর বা ইমেল ঠিকানা, এবং যা এই গোপনীয়তা নীতিতে "আপনার তথ্য" হিসাবে উল্লেখ করা হয়েছে), স্পিনবাজি (যার মধ্যে এর এজেন্ট এবং কর্মচারী অন্তর্ভুক্ত), এবং (যেখানে উপযুক্ত) আমাদের অংশীদার এবং উপ-ঠিকাদাররা খেলোয়াড়কে পরিষেবার সম্পূর্ণ পরিসর সরবরাহ করতে সক্ষম হওয়ার জন্য প্রক্রিয়া করবে। খেলোয়াড়ের তথ্য সংগ্রহ করা হয় যখন খেলোয়াড় স্পিনবাজিতে একটি অ্যাকাউন্ট খোলার জন্য নিবন্ধন করে; অথবা যখন খেলোয়াড় স্পিনবাজিতে একটি লিখিত প্রশ্ন জমা দেয়।',
      '2. যেকোনো পরিষেবা ব্যবহার করে, প্লেয়ার স্বীকার করে যে সে এই গোপনীয়তা নীতির শর্তাবলী পড়েছে এবং তাতে সম্মত হয়, এবং যেখানে প্লেয়ার আমাদের তথ্য প্রদান করে (সন্দেহ এড়ানোর জন্য, ওয়েবসাইটগুলির একটির মাধ্যমে আমাদের কাছে একটি প্রশ্ন জমা দেওয়ার মাধ্যমে, অথবা যেখানে প্লেয়ার শুধুমাত্র আংশিকভাবে একটি অ্যাকাউন্ট নিবন্ধন প্রক্রিয়া সম্পন্ন করে)।',
    ],
  },
  {
    title: 'আমরা কী ধরণের তথ্য সংগ্রহ করি এবং কীভাবে এটি ব্যবহার করি',
    list: [
      '১. স্পিনবাজি খেলোয়াড়দের তথ্য সংগ্রহ করে যাতে:\n     - আমাদের খেলোয়াড়ের অ্যাকাউন্ট সেট আপ করতে সক্ষম করুন যাতে সে পরিষেবার সমস্ত বৈশিষ্ট্যের পূর্ণ ব্যবহার করতে পারে, যার মধ্যে বাজি ধরা এবং গেম খেলা অন্তর্ভুক্ত;\n    - আমাদের অনলাইন সহায়তা কেন্দ্রের মাধ্যমে প্লেয়ারের কাছ থেকে প্রশ্ন এবং মন্তব্য গ্রহণ করতে এবং তাদের উত্তর দিতে সক্ষম করতে সক্ষম করুন;\n    - খেলোয়াড়ের নিবন্ধন সংক্রান্ত প্রাসঙ্গিক নিয়মকানুন মেনে চলা, উদাহরণস্বরূপ বয়স যাচাইকরণ পরীক্ষা সম্পন্ন করা; এবং\n     - স্পিনবাজির ভবিষ্যৎ ইভেন্ট, অফার এবং প্রচারণা সম্পর্কে খেলোয়াড়দের অবগত রাখা।\n     - উপরের অনুচ্ছেদ ১-এ চিহ্নিত বিস্তৃত উদ্দেশ্যগুলি ছাড়াও, Spinbaji শুধুমাত্র খেলোয়াড়ের তথ্য ব্যবহার করবে, যার মধ্যে রয়েছে আমাদের তৃতীয় পক্ষের অংশীদার এবং উপ-ঠিকাদারদের সাথে তথ্য ভাগ করে নেওয়া যারা আমাদের পক্ষ থেকে ডেটা প্রক্রিয়াকরণ করে (যেখানে উপযুক্ত, খেলোয়াড়ের তথ্য সহ):\n     - খেলোয়াড়ের অ্যাকাউন্ট স্থাপন, পরিচালনা, এবং পরিচালনা এবং রক্ষণাবেক্ষণ;\n     আমাদের কাছে অনুরোধ করা যেকোনো পরিষেবা প্রদান করা, এবং এই ধরনের বিধানের সাথে সম্পর্কিত যেকোনো যথাযথ উদ্দেশ্যে;\n     - খেলোয়াড়ের তথ্যের নির্ভুলতা যাচাই করা, যার মধ্যে রয়েছে তৃতীয় পক্ষের কাছে (আর্থিক প্রতিষ্ঠান, বয়স যাচাইকরণ এবং ক্রেডিট রিপোর্টিং এজেন্সি সহ) এই ধরনের উদ্দেশ্যে তথ্য প্রকাশ করা (অনুসন্ধানের একটি রেকর্ড সংরক্ষণ করা হবে এবং তৃতীয় পক্ষ যাচাইকরণের উদ্দেশ্যে অন্যান্য কোম্পানিগুলিকে সহায়তা করার জন্য তথ্য ব্যবহার করতে পারে);\n     - আপনার এবং অন্যান্য গ্রাহকদের পরিষেবা ব্যবহারের পরিসংখ্যান প্রস্তুত করা;\n     - উপযুক্ত ব্যক্তিগতকৃত বিপণন উপাদান এবং বিষয়বস্তু প্রস্তুত এবং প্রদর্শন করা;\n     - গুরুত্বপূর্ণ পরিষেবা পরিবর্তন, প্রযুক্তিগত সমস্যার আপডেট এবং নিয়মাবলীর সেটের পরিবর্তনগুলি (যার মধ্যে এই গোপনীয়তা নীতি অন্তর্ভুক্ত) ঘোষণা করার জন্য অ্যাকাউন্টধারীদের পর্যায়ক্রমে লিখিত বার্তা পাঠানো;\n     আইনি প্রয়োজনীয়তা মেনে চলা বা আইনি প্রক্রিয়া মেনে চলা বা ক্রীড়া সংস্থা বা অন্যান্য যোগ্য সংস্থার স্বার্থ রক্ষার জন্য কাজ করা;\n     - পরিষেবাগুলির সাথে সম্পর্কিত সন্দেহজনক বেআইনি, প্রতারণামূলক বা অন্যান্য অনুপযুক্ত কার্যকলাপের তদন্ত;\n     - অর্থ পাচার বা যেকোনো জালিয়াতি সহ কোনও অপরাধ বা সন্দেহজনক অপরাধের প্রতিবেদন করা; এবং\n     - খেলোয়াড়ের প্রতি আমাদের চুক্তিভিত্তিক বাধ্যবাধকতা পূরণের জন্য প্রয়োজনীয় অন্য কোনও উদ্দেশ্য।',
      '২. স্পিনবাজি খেলোয়াড়কে কোনও তৃতীয় পক্ষের বাণিজ্যিক অফার বা বিজ্ঞাপন সম্পর্কিত অযাচিত তথ্য পাঠাবে না।',
      '৩. বিজ্ঞাপন বা প্রচারণার উদ্দেশ্যে স্পিনবাজি খেলোয়াড়দের ব্যবহারকারীর নাম এবং/অথবা প্রথম নাম এবং অঞ্চল ব্যবহার করতে পারে।',
      '৪. প্রশিক্ষণ এবং নিরাপত্তার উদ্দেশ্যে আমাদের গ্রাহক পরিষেবা বিভাগে আসা এবং আসা টেলিফোন কল রেকর্ড করা হয়।',
      '৫. আমাদের ব্যবসা বা এর যেকোনো অংশ স্থানান্তর বা বিক্রি করার ক্ষেত্রে আমরা খেলোয়াড়ের তথ্য স্থানান্তর করতে পারি; দেউলিয়া হওয়ার ঘটনা সহ।',
      '৬. যদি কোনও সময়ে খেলোয়াড় উপরের উদ্দেশ্যে খেলোয়াড়ের তথ্য প্রক্রিয়াকরণ বন্ধ করতে চায়, তাহলে খেলোয়াড়কে অবশ্যই আমাদের সাথে যোগাযোগ করতে হবে এবং আমরা তা বন্ধ করার জন্য যথাযথ পদক্ষেপ নেব।',
    ],
  },
  {
    title: 'খেলোয়াড়দের তথ্য আপডেট করা হচ্ছে',
    content:
      "খেলোয়াড় Spinbaji অ্যাকাউন্ট থেকে যেকোনো সময় 'আমার অ্যাকাউন্ট/অ্যাকাউন্টের বিবরণ আপডেট করুন' (যেখানে উপলব্ধ) এর মাধ্যমে অথবা গ্রাহক পরিষেবার সাথে যোগাযোগ করে তার তথ্য আপডেট বা মুছে ফেলতে পারেন।",
  },
];
